<template>
<div class="row" id="categoryHeader">
    <loading :active='isLoading' :is-full-page="fullPage" :loader="loader" />
    <div class="col-md-3 left-side-bar" v-if="!roomBoolean">
        <nav class="navbar side-nav-font p-0" v-if="!store && !packageShow">
            <ul class="navbar-nav mt-2 p-0" >
            <li><b class="cCategorytitle">All Categories</b></li>
            <li class="nav-item">
                <span v-for="catg in categoryList" :key="catg.id" v-bind:id="catg.CategoryID"><a  class="nav-link collapsed" @click="handleClick(catg.CategoryID,categoryList,catg.ServiceCategory)" data-toggle="collapse" v-bind:href="catg.ProductCategoryHandle | includeHash" v-bind:data-target="catg.ProductCategoryHandle | includeHash"><span class="d-none d-sm-inline">{{catg.ServiceCategory}}</span></a>
                <div class="collapse" v-bind:id="catg.ProductCategoryHandle" aria-expanded="false">
                    <ul class="flex-column pl-2 nav cCursorhover" v-for="subcategory in subcategoryList" :key="subcategory.id">
                        <li v-if="catg.ProdCategoryID === subcategory.ParentProductCategoryID" v-bind:id="subcategory.ParentProductCategoryID" @click="handleSubCategoryClick(subcategory)" class="nav-item"><a class="nav-link py-0" ><span>{{subcategory.ProductCategory}}</span></a></li>
                    </ul>
                </div>
                <div class="dropdown-divider m-0"></div>
                </span>
            </li>
            </ul>
        </nav>

        <nav class="navbar side-nav-font p-0" v-if="store && !packageShow">
            <ul class="navbar-nav mt-2 p-0" >
                <li><b class="cCategorytitle">All Categories</b></li>
                <li class="nav-item">
                <span v-for="catg in categoryList" :key="catg.id" v-bind:id="catg.ProdCategoryID"><a  class="nav-link collapsed" @click="handleClick(catg.ProdCategoryID,categoryList,catg.ProductCategory)" data-toggle="collapse" v-bind:href="catg.ProductCategoryHandle | includeHash" v-bind:data-target="catg.ProductCategoryHandle | includeHash"><span class="d-none d-sm-inline">{{catg.ProductCategory}}</span></a>
                <div class="collapse" v-bind:id="catg.ProductCategoryHandle" aria-expanded="false">
                    <ul class="flex-column pl-2 nav cCursorhover" v-for="subcategory in subcategoryList" :key="subcategory.id">
                        <li v-if="catg.ProdCategoryID === subcategory.ParentProductCategoryID" v-bind:id="subcategory.ParentProductCategoryID" @click="handleSubCategoryClick(subcategory)" class="nav-item"><a class="nav-link py-0" ><span>{{subcategory.ProductCategory}}</span></a></li>
                    </ul>
                </div>
                <div class="dropdown-divider m-0"></div>
                </span>
                </li>
            </ul>
        </nav>


        <nav class="navbar side-nav-font p-0" v-if="!store && packageShow">
            <ul class="navbar-nav mt-2 p-0" >
                <li><b class="cCategorytitle">All Categories</b></li>
                <li class="nav-item">
                <span v-for="catg in packageCategory" :key="catg.id" v-bind:id="catg.PkCatID"><a  class="nav-link collapsed" @click="handleClick(catg.PkCatID,packageCategory,catg.PkCat)" data-toggle="collapse" v-bind:href="catg.ProductCategoryHandle | includeHash" v-bind:data-target="catg.ProductCategoryHandle | includeHash"><span class="d-none d-sm-inline">{{catg.PkCat}}</span></a>
                <div class="collapse" v-bind:id="catg.ProductCategoryHandle" aria-expanded="false">
                    <ul class="flex-column pl-2 nav cCursorhover" v-for="subcategory in subcategoryList" :key="subcategory.id">
                        <li v-if="catg.ProdCategoryID === subcategory.ParentProductCategoryID" v-bind:id="subcategory.ParentProductCategoryID" @click="handleSubCategoryClick(subcategory)" class="nav-item"><a class="nav-link py-0" ><span>{{subcategory.ProductCategory}}</span></a></li>
                    </ul>
                </div>
                <div class="dropdown-divider m-0"></div>
                </span>
                </li>
            </ul>
        </nav>

    </div>

    <div class="col-md-3 pt-3" v-if="roomBoolean">
                    <p class="font20 font500">About </p>
                    <p class="font14">Signature Hospitality, True Luxury In Victorian Era Design - Ever since the voyage of Seven Seas Hotel set sail, it has been creating waves in signature hospitality. Boasting of 13 event venues and more than 1 lakh square feet of event spaces, Seven Seas Hotel has become a much sought after destination for making any corporate or social event a memorable and resounding success. </p>
                    <p class="font20 font500">Ameneties </p>
                    <div class="row pl-3" v-for="item in items" :key="item.id">
                        <a class="text-dark mr-3" v-for="amenities in item[0].JSon6" :key="amenities.id">
                            <img width="20px" height="20px" v-bind:src="amenities.ImageURL" />
                            <p class="font10 font600">{{amenities.Amenity}}</p>
                        </a>
                        
                    </div>
                </div>
   
<div class="col-md-9 border-left border-right" v-if="!roomBoolean">

<div class="row mt-2" v-if="!bookSlotBoolean">
    <div class="col-md-11 col-11 align-self-center">
        <form>
            <div class="input-group">
                <input list="browsers" name="data_list"  class="form-control border-right-0 search-query" v-on:keyup="search($event)" v-bind:placeholder = "searchPlaceholder" id="data_list"  autofocus />
                <div class="input-group-prepend">
                    <div class="input-group-text border-left-0 search-icon search-query"><i class="fas fa-search text-muted"></i></div>
                </div>
            </div>
        </form>
    </div>
    <div class="col-md-1 col-1 pl-0 align-self-center">
        <div class="row">
            <div class="col toggle text-right pl-0" style="font-size:26px">
                <i v-if="!grid" @click="toggle()" class="toggleImg fa fa-list" id="toggle-product-views" aria-hidden="true"></i>
                <i v-if="grid" class="toggleImg fa fa-th" @click="toggle()" id="toggle-product-views" aria-hidden="true"></i>
            </div>
        </div>
    </div>
</div>

<div class="row mt-2">
    <div class="col-md-6 col-6 dairy pr-0">
        <p class="font-weight-bold mb-0"><i v-if="bookSlotBoolean" @click="backToListing()" class="fas fa-arrow-left mr-2"></i>{{activeElement}}</p>
    </div>
    <span id="openCustomizableModal" data-toggle="modal" data-target="#repeatItem"></span>
</div>

 <div class="row mb-5 fixed-bottom pr-3">
            <div class="col-md-12 text-right cross index-for-mobile" id="addModal">
                <a class="text-white open-beauty-add" data-toggle="modal" data-target="#beauty-add"><i class="fas fa-plus bottom-add-menu text-center"></i></a>
            </div>


            <div class="col-md-12 text-right">
                <button type="button" class="btn categories-button" data-toggle="modal" data-target="#categories">
                <span><i class="fas fa-bars mr-2"></i></span><span>Categories</span>
                </button>
            </div>
</div>

<div class="modal fade" id="beauty-add" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content beauty-modal border-0 fixed-bottom pb-5 mb-2">
            <div class="modal-body border-0">
                <div class="row text-right"  v-for="item in items" :key="item.id">
                    <div data-dismiss="modal"  class="col-md-12" @click="selectListingType('Services')">
                        <a class="beauty-modal-button text-white"><i class="fas fa-cube mr-3"></i>Service & Bookings </a>
                    </div>
                    <div data-dismiss="modal" v-if="packageCategory != undefined && packageCategory != ''" class="col-md-12 mt-4" @click="selectListingType('Packages')">
                        <a class="beauty-modal-button text-white"><i class="fas fa-cube mr-3"></i>Packages & More</a>
                    </div>
                    <div v-if="item[0].JSon0[0].HasOnlineStore == 'Y'" data-dismiss="modal" class="col-md-12 mt-4" @click="selectListingType('Store')">
                        <a class="beauty-modal-button text-white"><i class="fas fa-cart-plus mr-3"></i>Store</a>
                    </div>
                    <div data-dismiss="modal" class="col-md-12 mt-4" @click="selectListingType('Review')">
                        <a class="beauty-modal-button text-white"><i class="fas fa-store mr-3"></i>Review & Ratings</a>
                    </div>
                    <div class="col-md-12 mt-4 text-right custom-text-color cancel-button pr-2" id="cancelModal">
                        <a class="close-beauty-add" data-toggle="modal" data-target="#beauty-add">
                            <i class="fas fa-times bottom-add-menu bg-white text-center"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div v-if="!bookSlotBoolean">

<div class="scroll" @scroll="updateScroll" v-if="!noSearchItem && !store && !packageShow">
        <div  v-for="categoryName of categoryList" :key="categoryName.id" v-bind:id="categoryName.ServiceCategory" >
        <div class="row mt-3"  >
            <div class="col-md-5">
                <span v-bind:id="categoryName.ServiceCategory" class="heading-font-size2 cCategoryheading">{{categoryName.ServiceCategory}}</span>
            </div>
        </div>


<!-- eslint-disable -->
<div class="product-grid-view" v-if="grid">
    <div class="row pl-3 pr-3">
    <div class="col-6 col-md-6 col-lg-4 mt-3 mb-3" v-for="product in listItems" :key="product.id" v-if="categoryName.CategoryID === product.CategoryID" v-bind:id="product.ProductSubCategoryID">
            <div class="row product-img grid-view-desktop">
                <div class="col-md-12 p-0">
                    <div class="card border-0 pb-2 h-100" v-bind:id="product.ProductSubCategoryID">
                        
                    <div v-if="!mobile" >
                        <img v-if="product.MediaURL != '' && product.MediaURL != null" v-bind:src="product.MediaURL"  class="card-img list-img rounded" height="125px" width="125px"  alt="Responsive image">
                        <img v-if="product.MediaURL == '' || product.MediaURL== null" src="../assets/img/no_image.png" class="card-img list-img rounded" height="125px" width="125px" alt="Responsive image">
                    
                        
                        <div class="card-img-overlay p-0 pl-1 pt-1">
                         <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                            
                            <span v-if="product.SavingsText !=null && !easyCommerce" class="percent-offer offer-btn text-center float-right text-white"><small>{{product.SavingsText}}</small></span>
                        </div> 
                    </div>

                    <div v-if="mobile" >
                        <img v-if="product.CoverImageURL != '' && product.CoverImageURL != null" v-bind:src="product.CoverImageURL"  class="card-img list-img rounded" height="125px" width="125px"  alt="Responsive image">
                        <img v-if="product.CoverImageURL == '' || product.CoverImageURL== null" src="../assets/img/no_image.png" class="card-img list-img rounded" height="125px" width="125px" alt="Responsive image">
                    
                        
                        <div class="card-img-overlay p-0 pl-1 pt-1">
                         <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                            
                            <span v-if="product.SavingsText !=null && !easyCommerce" class="percent-offer offer-btn text-center float-right text-white"><small>{{product.SavingsText}}</small></span>
                        </div> 
                    </div>
                  
                        <p class="grid-heading mb-0 pl-2 mt-1"><b>{{product.CompanyService | nameLength}}</b></p>
                        <span class="service-duration pl-2">{{product.StandardServiceDuration}} Mins</span>
                        <div class="pl-2 mt-1">
                             <!--<span class="grid-variant">3 variants</span> -->

                        </div>

                        <div class="quantities pb-2">
                                    <span class="cCustomizableproduct" v-if="!easyCommerce && product.HasVariants == 'Y'" >Customizable</span>
                        </div>

                        <div class="row mt-1 pl-2 mt-auto">
                            <div class="col price pr-0 align-self-center">
                                <p   v-bind:id="product.CompanyService" class="product-price mr-1 mb-0">{{currency}} {{product.OfferPrice}}</p>
                                <span  v-if="product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ServiceID">{{currency}} {{product.MRP}}</del></span>
                                <p  v-if="product.HasVariants == 'Y' && variantList.length != 0" v-bind:id="product.ProductName" class="product-price mr-1 mb-0">{{product.CurrencyText}}{{product.variant.OfferPrice}}</p>
                                <span  v-if="product.HasVariants == 'Y' && variantList.length != 0 && product.variant.OfferPrice != product.variant.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.variant.MRP}}</del></span>
                                <p  v-if="product.HasVariants == 'Y' && !easyCommerce" v-bind:id="product.ProductName" class="product-price mr-1 mb-0">{{product.CurrencyText}}{{product.OfferPrice}}</p>
                                <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                            
                            </div>
                            <div class="col pl-0 align-self-center">
                              

                            <buttton  name="add" v-bind:id="product.ServiceID | increment" @click="bookSlots(product)" class="btn btn-sm float-right pl-1"><span class="add-button add-list-view cCursorhover">BOOK</span></buttton>
                            <buttton  name="add" v-bind:id="product.ServiceID | newVariant"  class="btn btn-sm float-right pl-1 incr"><span class="add-button add-list-view cCursorhover">ADDED</span></buttton>

                        
        
                            <buttton v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName | increment" name="add" data-toggle="modal" data-target="#comboModal" @click="FCsendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

   <div class="product-list-view homepage-for-desktop" v-if="!grid && !mobile">
    <div class="row pl-3">
        <div class="col-md-12" v-for="product in listItems" :key="product.id" v-if="categoryName.CategoryID === product.CategoryID">
            <div class="row mt-3 mb-3">
                <div class="col-md-4">
                    <div class="row list-view-desktop product-img">
                        <div class="col-md-12 p-0">
                            <div class="card border-0" v-bind:id="product.ProductSubCategoryID" >
                                <img v-if="product.MediaURL != '' && product.MediaURL != null" v-bind:src="product.MediaURL"  class="card-img list-img rounded"  alt="Responsive image">
                                <img v-if="product.MediaURL == '' || product.MediaURL== null" src="../assets/img/no_image.png"  class="card-img list-img rounded" alt="Responsive image">
                                <div class="card-img-overlay p-0 pl-1 pt-1">
                                    <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                                    <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                                    <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                                    <span v-if="product.SavingsText !=null && !easyCommerce" class="percent-offer offer-btn text-center float-right text-white"><small>{{product.SavingsText}}</small></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 product-heading">
                    <div class="row">
                        <div class="col-md-8 p-0">
                            <a >
                                <span>{{product.CompanyService | nameLength}}</span>
                            </a>
                            <div><span class="service-duration">{{product.StandardServiceDuration}} Mins</span></div>
                            <span class="float-center">
                                <div class="price">
                                <span   v-bind:id="product.CompanyService" class="product-price">{{currency}} {{product.OfferPrice}}</span>
                                <span  v-if="product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ServiceID">{{currency}} {{product.MRP}}</del></span>
                               
                                <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName" class="product-price">{{product.CurrencyText}}{{product.OfferPrice}}</span>
                                <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                                </div>
                                <button v-if="product.TagJSON != null" class="btn btn-small bestselling-btn btn-danger text-white">{{JSON.parse(product.TagJSON)[0].Tag}}</button>
                                

                                <div class="quantities pb-2">
                                    <span class="cCustomizableproduct" v-if="!easyCommerce && product.VV == 'C'" >Customizable</span>
                                </div>
                            </span>
                            <p v-bind:id="product.ServiceID | readmore" class="bestselling mb-0">{{product.ServiceDescription | descLength}}<span @click="readMore(product.ServiceID)" class="cCursorhover" style="font-size : 12px;color:#3A1593" v-if="product.ServiceDescription != '' && product.ServiceDescription != null && product.ServiceDescription.length > 100"> ...read more</span></p>
                            <p v-bind:id="product.ServiceID | readless" class="bestselling mb-0 incr">{{product.ServiceDescription}} <span @click="readLess(product.ServiceID)" class="cCursorhover" style="font-size : 12px;color:#3A1593"> ...read less</span></p>
                        </div>
                        <div class="col-md-4 pl-0 mt-1 tab-media cBtnscrollbar">
                            <buttton v-if="product.AddOnServices == null"  name="add" v-bind:id="product.ServiceID | increment" @click="bookSlots(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">BOOK</span></buttton>
                            <buttton v-if="product.AddOnServices != null" name="add" v-bind:id="product.ServiceID | increment" data-toggle="modal" data-target="#variantModal" @click="openVariantModal(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">BOOK</span></buttton>
                            <buttton  name="add" v-bind:id="product.ServiceID | newVariant"  class="add-circle list-view float-right cCursorhover incr"><span class="add-button add-list-view">ADDED</span></buttton>
                        

                            <buttton v-if="product.HasVariants == 'Y' && product.VV != 'C'"  name="add" v-bind:id="product.ProductHandle | increment" data-toggle="modal" data-target="#addToCartModal" @click="sendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>
                            <buttton v-if="product.HasVariants == 'Y' && product.VV != 'C'" name="add" v-bind:id="product.ProductHandle | newVariant" data-toggle="modal" data-target="#addToCartModal" @click="sendInfo(product)" class="add-circle list-view float-right cCursorhover incr"><span class="add-button add-list-view">EDIT +</span></buttton>
                            <buttton v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductHandle | increment" name="add" data-toggle="modal" data-target="#comboModal" @click="FCsendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

 

<div class="row product-list-for-mobile index-for-mobile" v-if="!grid && mobile">
    <div class="col-md-12" v-for="product in listItems" :key="product.id" v-if="categoryName.ProdCategoryID === product.ProductCategoryID">
        <div class="row mt-3 mb-4">
            <div class="col-4">
                <div class="card border-0 list-view-mobile product-img" v-bind:id="product.ProductSubCategoryID" >
                <div >
                    <img  v-if="product.MediaURL != '' && product.MediaURL != null" v-bind:src="product.MediaURL"  class="card-img list-img rounded" height="93px" width="68px" alt="Responsive image">
                    <img  v-if="product.MediaURL == '' || product.MediaURL== null" src="../assets/img/no_image.png"  class="card-img list-img rounded" height="93px" width="68px" alt="Responsive image">
               
                   <div class="cNatureindicator p-0 d-flex">
                         <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                    </div>
                </div>
                        <div class="text-center bottom-btn-add">
                           
                            <buttton  name="add" v-bind:id="product.ServiceID | increment" @click="bookSlots(product)" class="cCursorhover"><span class="btn-add text-white add-clickbtn">BOOK</span></buttton>
                            <buttton  name="add" v-bind:id="product.ServiceID | newVariant" class="cCursorhover incr"><span class="btn-add text-white add-clickbtn">ADDED</span></buttton>
                        
                            <buttton v-if="product.HasVariants == 'Y' && product.VV != 'C'"  name="add" v-bind:id="product.ProductHandle | increment" data-toggle="modal" data-target="#addToCartModal" @click="sendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>
                            <buttton v-if="product.HasVariants == 'Y' && product.VV != 'C'" name="add" v-bind:id="product.ProductHandle | newVariant" data-toggle="modal" data-target="#addToCartModal" @click="sendInfo(product)" class="add-circle list-view float-right cCursorhover incr"><span class="add-button add-list-view">EDIT +</span></buttton>
                            <buttton v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName | increment" name="add" data-toggle="modal" data-target="#comboModal" @click="FCsendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>
                        </div>
                    
                </div>
            </div>
            <div class="col-8">
                <a>
                    <span class="product-heading-mobile">{{product.CompanyService | nameLength}}</span>
                </a>
                <div><span class="service-duration">{{product.StandardServiceDuration}} Mins</span></div>
                <span class="float-center">
                    <div class="price">
                        <span   v-bind:id="product.CompanyService" class="product-price">{{currency}} {{product.OfferPrice}}</span>
                        <span  v-if="product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ServiceID">{{currency}} {{product.MRP}}</del></span>
                        <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName" class="product-price">{{product.CurrencyText}}{{product.OfferPrice}}</span>
                        <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                        <span v-if="product.SavingsText !=null && !easyCommerce" class="off">{{product.SavingsText}}</span>
                    </div>
                    
                    <a v-if="product.TagJSON != null"  class="btn btn-small bestselling-btn btn-danger text-white">{{JSON.parse(product.TagJSON)[0].Tag}}</a>
                    
                    
                    <div class="quantities pb-2">
                                    <span class="cCustomizableproduct" v-if="!easyCommerce && product.VV == 'C'" >Customizable</span>
                    </div>
                </span>
                <p v-bind:id="product.ServiceID | readmore" class="bestselling mb-0">{{product.ServiceDescription | descLength}}<span @click="readMore(product.ServiceID)" class="cCursorhover" style="font-size : 12px;color:#3A1593" v-if="product.ServiceDescription != '' && product.ServiceDescription != null && product.ServiceDescription.length > 100"> ...read more</span></p>
                <p v-bind:id="product.ServiceID | readless" class="bestselling mb-0 incr">{{product.ServiceDescription}} <span @click="readLess(product.ServiceID)" class="cCursorhover" style="font-size : 12px;color:#3A1593"> ...read less</span></p>
            </div>
        </div>
    
</div>
</div>
</div>
</div>

<div class="scroll" @scroll="updateScroll" v-if="!noSearchItem && store && !packageShow">
        <div  v-for="categoryName of categoryList" :key="categoryName.id" v-bind:id="categoryName.ProductCategory" >
        <div class="row mt-3"  >
            <div class="col-md-5">
                <span v-bind:id="categoryName.ProductCategory" class="heading-font-size2 cCategoryheading">{{categoryName.ProductCategory}}</span>
            </div>
        </div>


<!-- eslint-disable -->
<div class="product-grid-view" v-if="grid">
    <div class="row pl-3 pr-3">
    <div class="col-6 col-md-6 col-lg-4 mt-3 mb-3" v-for="product in listItems" :key="product.id" v-if="categoryName.ProdCategoryID === product.ProductCategoryID" v-bind:id="product.ProductSubCategoryID">
            <div class="row product-img grid-view-desktop">
                <div class="col-md-12 p-0">
                    <div class="card border-0 pb-2 h-100" v-bind:id="product.ProductSubCategoryID">
                        
                    <div v-if="!mobile" >
                        <img v-if="product.CoverImageURL != '' && product.CoverImageURL != null" v-bind:src="product.CoverImageURL"  class="card-img list-img rounded" height="125px" width="125px"  alt="Responsive image">
                        <img v-if="product.CoverImageURL == '' || product.CoverImageURL== null" src="../assets/img/no_image.png" class="card-img list-img rounded" height="125px" width="125px" alt="Responsive image">
                    
                        
                        <div class="card-img-overlay p-0 pl-1 pt-1">
                         <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                            
                            <span v-if="product.SavingsText !=null && !easyCommerce" class="percent-offer offer-btn text-center float-right text-white"><small>{{product.SavingsText}}</small></span>
                        </div> 
                    </div>

                    <div v-if="mobile" >
                        <img v-if="product.CoverImageURL != '' && product.CoverImageURL != null" v-bind:src="product.CoverImageURL"  class="card-img list-img rounded" height="125px" width="125px"  alt="Responsive image">
                        <img v-if="product.CoverImageURL == '' || product.CoverImageURL== null" src="../assets/img/no_image.png" class="card-img list-img rounded" height="125px" width="125px" alt="Responsive image">
                    
                        
                        <div class="card-img-overlay p-0 pl-1 pt-1">
                         <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                            
                            <span v-if="product.SavingsText !=null && !easyCommerce" class="percent-offer offer-btn text-center float-right text-white"><small>{{product.SavingsText}}</small></span>
                        </div> 
                    </div>
                  
                        <p class="grid-heading mb-0 pl-2 mt-1"><b>{{product.ProductName | nameLength}}</b></p>
                        <div class="pl-2 mt-1">
                             <!--<span class="grid-variant">3 variants</span> -->

                        </div>

                        <div class="quantities pb-2">
                                    <span class="cCustomizableproduct" v-if="!easyCommerce && product.HasVariants == 'Y'" >Customizable</span>
                        </div>

                        <div class="row mt-1 pl-2 mt-auto">
                            <div class="col price pr-0 align-self-center">
                                <p  v-if="product.HasVariants == 'N'" v-bind:id="product.ProductName" class="product-price mr-1 mb-0">{{currency}} {{product.OfferPrice}}</p>
                                <span  v-if="product.HasVariants == 'N' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{currency}} {{product.MRP}}</del></span>
                                <p  v-if="product.HasVariants == 'Y' && variantList.length != 0" v-bind:id="product.ProductName" class="product-price mr-1 mb-0">{{product.CurrencyText}}{{product.variant.OfferPrice}}</p>
                                <span  v-if="product.HasVariants == 'Y' && variantList.length != 0 && product.variant.OfferPrice != product.variant.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.variant.MRP}}</del></span>
                                <p  v-if="product.HasVariants == 'Y' && !easyCommerce" v-bind:id="product.ProductName" class="product-price mr-1 mb-0">{{product.CurrencyText}}{{product.OfferPrice}}</p>
                                <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                            
                            </div>
                            <div class="col pl-0 align-self-center">
                              

                            <buttton v-if="product.HasVariants == 'N'" name="add" v-bind:id="product.ProductHandle | increment" @click="addItem(product)" class="btn btn-sm float-right pl-1"><span class="add-button add-list-view cCursorhover">ADD +</span></buttton>
                            

                        <div v-if="product.HasVariants == 'N' || product.VV=='C'" class="quantity-btn text-right increment-btn incr" v-bind:id="product.ProductHandle | newVariant"> 
                            <div class="btn-group">  
                           <button class="qantity-decrement btn btn-sm custom-quantity-btn operator-btn text-white border-0" @click="addProductQuantity(product.ProductHandle,product.ProductName)">+</button>
                            <input class="product-quantity custom-quantity-btn count-quantity text-white quantity border-0 text-center"  v-bind:id="product.ProductHandle | productQuantity" type="number" name="quantity" min="1" max="10" value="0" readonly/>
                             <button class="quantity-increment btn btn-sm custom-quantity-btn operator-btn text-white border-0" @click="minusProductQuantity(product.ProductHandle,product.ProductName)">-</button>
                            </div>
                        </div>
                            
                           
                            <buttton v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName | increment" name="add" data-toggle="modal" data-target="#variantModal" @click="FCsendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

   <div class="product-list-view homepage-for-desktop" v-if="!grid && !mobile">
    <div class="row pl-3">
        <div class="col-md-12" v-for="product in listItems" :key="product.id" v-if="categoryName.ProdCategoryID === product.ProductCategoryID">
            <div class="row mt-3 mb-3">
                <div class="col-md-4">
                    <div class="row list-view-desktop product-img">
                        <div class="col-md-12 p-0">
                            <div class="card border-0" v-bind:id="product.ProductSubCategoryID" >
                                <img v-if="product.CoverImageURL != '' && product.CoverImageURL != null" v-bind:src="product.CoverImageURL"  class="card-img list-img rounded"  alt="Responsive image">
                                <img v-if="product.CoverImageURL == '' || product.CoverImageURL== null" src="../assets/img/no_image.png"  class="card-img list-img rounded" alt="Responsive image">
                                <div class="card-img-overlay p-0 pl-1 pt-1">
                                    <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                                    <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                                    <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                                    <span v-if="product.SavingsText !=null && !easyCommerce" class="percent-offer offer-btn text-center float-right text-white"><small>{{product.SavingsText}}</small></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 product-heading">
                    <div class="row">
                        <div class="col-md-8 p-0">
                            <a >
                                <span>{{product.ProductName | nameLength}}</span>
                            </a>
                            <span class="float-center">
                                <div class="price">
                                <span  v-if="product.HasVariants == 'N'" v-bind:id="product.ProductName" class="product-price">{{currency}} {{product.OfferPrice}}</span>
                                <span  v-if="product.HasVariants == 'N' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{currency}} {{product.MRP}}</del></span>
                                
                                <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName" class="product-price">{{product.CurrencyText}}{{product.OfferPrice}}</span>
                                <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                                </div>
                                <button v-if="product.TagJSON != null" class="btn btn-small bestselling-btn btn-danger text-white">{{JSON.parse(product.TagJSON)[0].Tag}}</button>
                                
                                
                                <div class="quantities pb-2">
                                    <span class="cCustomizableproduct" v-if="!easyCommerce && product.VV == 'C'" >Customizable</span>
                                </div>
                            </span>
                            <p v-bind:id="product.ProductHandle | readmore" class="bestselling mb-0">{{product.ProductDescription | descLength}}<span @click="readMore(product.ProductHandle)" class="cCursorhover" style="font-size : 12px;color:#3A1593" v-if="product.ProductDescription != '' && product.ProductDescription != null && product.ProductDescription.length > 100"> ...read more</span></p>
                            <p v-bind:id="product.ProductHandle | readless" class="bestselling mb-0 incr">{{product.ProductDescription}} <span @click="readLess(product.ProductHandle)" class="cCursorhover" style="font-size : 12px;color:#3A1593"> ...read less</span></p>
                        </div>
                        <div class="col-md-4 pl-0 mt-1 tab-media cBtnscrollbar">
                            <buttton v-if="product.HasVariants == 'N'" name="add" v-bind:id="product.ProductHandle | increment" @click="addItem(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>

                        <div v-if="product.HasVariants == 'N' || product.VV=='C'" class="quantity-btn text-right increment-btn incr" v-bind:id="product.ProductHandle | newVariant"> 
                            <div class="btn-group">  
                            <button class="qantity-decrement btn btn-sm custom-quantity-btn operator-btn text-white border-0" @click="addProductQuantity(product.ProductHandle,product.ProductName)">+</button>
                            <input class="product-quantity custom-quantity-btn count-quantity text-white quantity border-0 text-center"  v-bind:id="product.ProductHandle | productQuantity" type="number" name="quantity" min="1" max="10" value="0" readonly/>
                            <button class="quantity-increment btn btn-sm custom-quantity-btn operator-btn text-white border-0" @click="minusProductQuantity(product.ProductHandle,product.ProductName)">-</button> 
                            </div>
                        </div>

                            <buttton v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductHandle | increment" name="add" data-toggle="modal" data-target="#variantModal" @click="FCsendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row product-list-for-mobile index-for-mobile" v-if="!grid && mobile">
    <div class="col-md-12" v-for="product in listItems" :key="product.id" v-if="categoryName.ProdCategoryID === product.ProductCategoryID">
        <div class="row mt-3 mb-4">
            <div class="col-4">
                <div class="card border-0 list-view-mobile product-img" v-bind:id="product.ProductSubCategoryID" >
                <div>
                    <img  v-if="product.CoverImageURL != '' && product.CoverImageURL != null" v-bind:src="product.CoverImageURL"  class="card-img list-img rounded" height="93px" width="68px" alt="Responsive image">
                    <img  v-if="product.CoverImageURL == '' || product.CoverImageURL== null" src="../assets/img/no_image.png"  class="card-img list-img rounded" height="93px" width="68px" alt="Responsive image">
               
                   <div class="cNatureindicator p-0 d-flex">
                         <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                    </div>
                </div>
                        <div class="text-center bottom-btn-add">
                           
                            <buttton v-if="product.HasVariants == 'N'" name="add" v-bind:id="product.ProductHandle | increment" @click="addItem(product)" class="cCursorhover"><span class="btn-add text-white add-clickbtn">ADD +</span></buttton>

                        <div v-if="product.HasVariants == 'N' || product.VV=='C'" class="quantity-btn text-right increment-btn incr" v-bind:id="product.ProductHandle | newVariant"> 
                            <div class="btn-group">  
                            <button class="qantity-decrement btn btn-sm custom-quantity-btn operator-btn text-white border-0" @click="addProductQuantity(product.ProductHandle,product.ProductName)">+</button>
                            <input class="product-quantity custom-quantity-btn count-quantity text-white quantity border-0 text-center"  v-bind:id="product.ProductHandle | productQuantity" type="number" name="quantity" min="1" max="10" value="0" readonly/>
                            <button class="quantity-increment btn btn-sm custom-quantity-btn operator-btn text-white border-0" @click="minusProductQuantity(product.ProductHandle,product.ProductName)">-</button>
                            </div>
                        </div>
                 
                            <buttton v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName | increment" name="add" data-toggle="modal" data-target="#comboModal" @click="FCsendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>
                        </div>
                    
                </div>
            </div>
            <div class="col-8">
                <a>
                    <span class="product-heading-mobile">{{product.ProductName | nameLength}}</span>
                </a>

              

                <span class="float-center">
                    <div class="price">
                        <span  v-if="product.HasVariants == 'N'" v-bind:id="product.ProductName" class="product-price">{{product.CurrencyText}}{{product.OfferPrice}}</span>
                        <span  v-if="product.HasVariants == 'N' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                       
                        <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName" class="product-price">{{product.CurrencyText}}{{product.OfferPrice}}</span>
                        <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                        <span v-if="product.SavingsText !=null && !easyCommerce" class="off">{{product.SavingsText}}</span>
                    </div>
                    
                    <a v-if="product.TagJSON != null"  class="btn btn-small bestselling-btn btn-danger text-white">{{JSON.parse(product.TagJSON)[0].Tag}}</a>
                    
  
                    <div class="quantities pb-2">
                                    <span class="cCustomizableproduct" v-if="!easyCommerce && product.VV == 'C'" >Customizable</span>
                    </div>
                </span>
                <p v-bind:id="product.ProductHandle | readmore" class="bestselling mb-0">{{product.ProductDescription | descLength}}<span @click="readMore(product.ProductHandle)" class="cCursorhover" style="font-size : 12px;color:#3A1593" v-if="product.ProductDescription != '' && product.ProductDescription != null && product.ProductDescription.length > 100"> ...read more</span></p>
                <p v-bind:id="product.ProductHandle | readless" class="bestselling mb-0 incr">{{product.ProductDescription}} <span @click="readLess(product.ProductHandle)" class="cCursorhover" style="font-size : 12px;color:#3A1593"> ...read less</span></p>
            </div>
        </div>
    </div>
    
</div>
</div>
</div>

<div class="scroll" @scroll="updateScroll" v-if="!noSearchItem && !store && packageShow">
        <div  v-for="categoryName of packageCategory" :key="categoryName.id" v-bind:id="categoryName.PkCat" >
        <div class="row mt-3"  >
            <div class="col-md-5">
                <span v-bind:id="categoryName.PkCat" class="heading-font-size2 cCategoryheading">{{categoryName.PkCat}}</span>
            </div>
        </div>


<!-- eslint-disable -->
<div class="product-grid-view" v-if="grid">
    <div class="row pl-3 pr-3">
    <div class="col-6 col-md-6 col-lg-4 mt-3 mb-3" v-for="product in packagesList" :key="product.id"  v-if="categoryName.PkCatID === product.PkCatID">
            <div class="row product-img grid-view-desktop">
                <div class="col-md-12 p-0">
                    <div class="card border-0 pb-2 h-100" >
                        
                    <div v-if="!mobile">
                        <img v-if="product.MediaJSON != '' && product.MediaJSON != null" v-bind:src="JSON.parse(product.MediaJSON)[0].MediaURL"  class="card-img list-img rounded" height="125px" width="125px"  alt="Responsive image">
                        <img v-if="product.MediaJSON == '' || product.MediaJSON== null" src="../assets/img/no_image.png" class="card-img list-img rounded" height="125px" width="125px" alt="Responsive image">
                    
                        
                        <div class="card-img-overlay p-0 pl-1 pt-1">
                         <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                            
                            <span v-if="product.SavingsText !=null && !easyCommerce" class="percent-offer offer-btn text-center float-right text-white"><small>{{product.SavingsText}}</small></span>
                        </div> 
                    </div>

                    
                  
                        <p class="grid-heading mb-0 pl-2 mt-1"><b>{{product.PackageName | nameLength}}</b></p>
                        <div class="pl-2 mt-1">
                             <!--<span class="grid-variant">3 variants</span> -->

                        </div>

                        <div class="quantities pb-2">
                                    <span class="cCustomizableproduct" v-if="!easyCommerce && product.HasVariants == 'Y'" >Customizable</span>
                        </div>

                        <div class="row mt-1 pl-2 mt-auto">
                            <div class="col price pr-0 align-self-center">
                                <p  v-bind:id="product.PackageName" class="product-price mr-1 mb-0">{{product.CurrencyText}}{{product.Price}}</p>
                                <span  v-if="product.HasVariants == 'N' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                                <p  v-if="product.HasVariants == 'Y' && variantList.length != 0" v-bind:id="product.ProductName" class="product-price mr-1 mb-0">{{product.CurrencyText}}{{product.variant.OfferPrice}}</p>
                                <span  v-if="product.HasVariants == 'Y' && variantList.length != 0 && product.variant.OfferPrice != product.variant.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.variant.MRP}}</del></span>
                                <p  v-if="product.HasVariants == 'Y' && !easyCommerce" v-bind:id="product.ProductName" class="product-price mr-1 mb-0">{{product.CurrencyText}}{{product.OfferPrice}}</p>
                                <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                            
                            </div>
                            <div class="col pl-0 align-self-center">
                              

                            <buttton name="add" v-bind:id="product.PackageHandle | increment" @click="bookSlots(product)" class="btn btn-sm float-right pl-1"><span class="add-button add-list-view cCursorhover">BOOK</span></buttton>
                            <buttton name="add" v-bind:id="product.PackageHandle | newVariant" class="btn btn-sm float-right pl-1 incr"><span class="add-button add-list-view cCursorhover">ADDED</span></buttton>
                            

                            <buttton v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName | increment" name="add" data-toggle="modal" data-target="#variantModal" @click="FCsendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

   <div class="product-list-view homepage-for-desktop" v-if="!grid && !mobile">
    <div class="row pl-3">
        <div class="col-md-12" v-for="product in packagesList" :key="product.id" v-if="categoryName.PkCatID === product.PkCatID">
            <div class="row mt-3 mb-3">
                <div class="col-md-4">
                    <div class="row list-view-desktop product-img">
                        <div class="col-md-12 p-0">
                            <div class="card border-0" >
                                <img v-if="product.MediaJSON != '' && product.MediaJSON != null" v-bind:src="JSON.parse(product.MediaJSON)[0].MediaURL"  class="card-img list-img rounded"  alt="Responsive image">
                                <img v-if="product.MediaJSON == '' || product.MediaJSON== null" src="../assets/img/no_image.png"  class="card-img list-img rounded" alt="Responsive image">
                                <div class="card-img-overlay p-0 pl-1 pt-1">
                                    <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                                    <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                                    <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                                    <span v-if="product.SavingsText !=null && !easyCommerce" class="percent-offer offer-btn text-center float-right text-white"><small>{{product.SavingsText}}</small></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 product-heading">
                    <div class="row">
                        <div class="col-md-8 p-0">
                            <a >
                                <span>{{product.PackageName | nameLength}}</span>
                            </a>
                            <span class="float-center">
                                <div class="price">
                                <span  v-bind:id="product.PackageName" class="product-price">{{currency}} {{product.Price}}</span>
                                <span  v-if="product.HasVariants == 'N' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                               
                                <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName" class="product-price">{{product.CurrencyText}}{{product.OfferPrice}}</span>
                                <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                                </div>
                                <button v-if="product.TagJSON != null" class="btn btn-small bestselling-btn btn-danger text-white">{{JSON.parse(product.TagJSON)[0].Tag}}</button>
                                
                                
                                <div class="quantities pb-2">
                                    <span class="cCustomizableproduct" v-if="!easyCommerce && product.VV == 'C'" >Customizable</span>
                                </div>
                            </span>
                            <p v-bind:id="product.PackageHandle | readmore" class="bestselling mb-0">{{product.PackageDescription | descLength}}<span @click="readMore(product.PackageHandle)" class="cCursorhover" style="font-size : 12px;color:#3A1593" v-if="product.PackageDescription != '' && product.PackageDescription != null && product.PackageDescription.length > 100"> ...read more</span></p>
                            <p v-bind:id="product.PackageHandle | readless" class="bestselling mb-0 incr">{{product.PackageDescription}} <span @click="readLess(product.PackageHandle)" class="cCursorhover" style="font-size : 12px;color:#3A1593"> ...read less</span></p>
                        </div>
                        <div class="col-md-4 pl-0 mt-1 tab-media cBtnscrollbar">
                            <buttton  name="add" v-bind:id="product.PackageHandle | increment" @click="bookSlots(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">BOOK</span></buttton>
                            <buttton  name="add" v-bind:id="product.PackageHandle | newVariant" class="add-circle list-view float-right cCursorhover incr"><span class="add-button add-list-view">ADDED</span></buttton>
                       
         
                            <buttton v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductHandle | increment" name="add" data-toggle="modal" data-target="#variantModal" @click="FCsendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row product-list-for-mobile index-for-mobile" v-if="!grid && mobile">
    <div class="col-md-12" v-for="product in packagesList" :key="product.id" v-if="categoryName.PkCatID === product.PkCatID">
        <div class="row mt-3 mb-4">
            <div class="col-4">
                <div class="card border-0 list-view-mobile product-img" v-bind:id="product.ProductSubCategoryID" >
                <div >
                    <img  v-if="product.MediaJSON != '' && product.MediaJSON != null" v-bind:src="JSON.parse(product.MediaJSON)[0].MediaURL"  class="card-img list-img rounded" height="93px" width="68px" alt="Responsive image">
                    <img  v-if="product.MediaJSON == '' || product.MediaJSON== null" src="../assets/img/no_image.png"  class="card-img list-img rounded" height="93px" width="68px" alt="Responsive image">
               
                   <div class="cNatureindicator p-0 d-flex">
                         <img v-if="!easyCommerce && product.NatureIndicator == 'E'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/egg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'V'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/veg.png"  alt="Card image" class="cProductnature">
                        <img v-if="!easyCommerce && product.NatureIndicator == 'N'" src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/nonveg.png"  alt="Card image" class="cProductnature">
                    </div>
                </div>
                        <div class="text-center bottom-btn-add">
                           
                            <buttton  name="add" v-bind:id="product.PackageHandle | increment" @click="bookSlots(product)" class="cCursorhover"><span class="btn-add text-white add-clickbtn">BOOK</span></buttton>
                            <buttton  name="add" v-bind:id="product.PackageHandle | newVariant"  class="cCursorhover incr"><span class="btn-add text-white add-clickbtn">ADDED</span></buttton>
                    
                            
                            <buttton v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName | increment" name="add" data-toggle="modal" data-target="#comboModal" @click="FCsendInfo(product)" class="add-circle list-view float-right cCursorhover"><span class="add-button add-list-view">ADD +</span></buttton>
                        </div>
                    
                </div>
            </div>
            <div class="col-8">
                <a>
                    <span class="product-heading-mobile">{{product.PackageName | nameLength}}</span>
                </a>

              

                <span class="float-center">
                    <div class="price">
                        <span v-bind:id="product.ProductName" class="product-price">{{currency}} {{product.Price}}</span>
                        <!-- <span  v-if="product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">Rs {{product.MRP}}</del></span> -->
                      
                        <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C'" v-bind:id="product.ProductName" class="product-price">{{product.CurrencyText}}{{product.OfferPrice}}</span>
                        <span  v-if="product.HasVariants == 'Y' && !easyCommerce && product.VV == 'C' && product.OfferPrice != product.MRP" class="product-price-del" ><del v-bind:id="product.ProductHandle">{{product.CurrencyText}}{{product.MRP}}</del></span>
                        <span v-if="product.SavingsText !=null && !easyCommerce" class="off">{{product.SavingsText}}</span>
                    </div>
                    
                    <a v-if="product.TagJSON != null"  class="btn btn-small bestselling-btn btn-danger text-white">{{JSON.parse(product.TagJSON)[0].Tag}}</a>
                    
                    
                    <div class="quantities pb-2">
                                    <span class="cCustomizableproduct" v-if="!easyCommerce && product.VV == 'C'" >Customizable</span>
                    </div>
                </span>
                <p v-bind:id="product.PackageHandle | readmore" class="bestselling mb-0">{{product.PackageDescription | descLength}}<span @click="readMore(product.PackageHandle)" class="cCursorhover" style="font-size : 12px;color:#3A1593" v-if="product.PackageDescription != '' && product.PackageDescription != null && product.PackageDescription.length > 100"> ...read more</span></p>
                <p v-bind:id="product.PackageHandle | readless" class="bestselling mb-0 incr">{{product.PackageDescription}} <span @click="readLess(product.PackageHandle)" class="cCursorhover" style="font-size : 12px;color:#3A1593"> ...read less</span></p>
            </div>
        </div>
    </div>
    
</div>
</div>
</div>
</div>

<div v-if="bookSlotBoolean">
            <!-- <div class="scrolling-wrapper-flexbox" v-if="productToBeScheduled.AllowSpecialistSelection == 'Y'">
                        <div class="col-md-4 col-4 col-lg-3 dr-list dr-card border-0 text-center m-2 p-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <img src="../assets/img/hospital/Ellipse 651.svg" class="img-fluid rounded-circle doctore-img" alt="doctor-image">
                                </div>
                                <div class="col-md-12">
                                    <p class="mb-0 dr-name">Dr. Sanjeev Dua</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-4 col-lg-3 dr-list dr-card border-0 text-center m-2 p-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <img src="../assets/img/hospital/Ellipse 652.svg" class="img-fluid rounded-circle doctore-img" alt="doctor-image">
                                </div>
                                <div class="col-md-12">
                                    <p class="mb-0 dr-name">Dr. Sanjeev Dua</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-4 col-lg-3 dr-list dr-card border-0 text-center m-2 p-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <img src="../assets/img/hospital/Ellipse 657.svg" class="img-fluid rounded-circle doctore-img" alt="doctor-image">
                                </div>
                                <div class="col-md-12">
                                    <p class="mb-0 dr-name">Dr. Sanjeev Dua</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-4 col-lg-3 dr-list dr-card border-0 text-center m-2 p-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <img src="../assets/img/hospital/Ellipse 654.svg" class="img-fluid rounded-circle doctore-img" alt="doctor-image">
                                </div>
                                <div class="col-md-12">
                                    <p class="mb-0 dr-name">Dr. Sanjeev Dua</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-4 col-lg-3 dr-list dr-card border-0 text-center m-2 p-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <img src="../assets/img/hospital/Ellipse 652.svg" class="img-fluid rounded-circle doctore-img" alt="doctor-image">
                                </div>
                                <div class="col-md-12">
                                    <p class="mb-0 dr-name">Dr. Sanjeev Dua</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-4 col-lg-3 dr-list dr-card border-0 text-center m-2 p-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <img src="../assets/img/hospital/Ellipse 651.svg" class="img-fluid rounded-circle doctore-img" alt="doctor-image">
                                </div>
                                <div class="col-md-12">
                                    <p class="mb-0 dr-name">Dr. Sanjeev Dua</p>
                                </div>
                            </div>
                        </div>
            </div>
                    <div class="row mt-3" v-if="productToBeScheduled.AllowSpecialistSelection == 'Y'">
                        <div class="col-md-12">
                            <p class="dr-fee mb-0">Consultation Fee: ₹ 1200</p>
                        </div>
                    </div> -->


            <div class="row mt-3">
                        <div class="col-md-12">
                            <p class="dr-day mb-0">Select Service Location</p>
                        </div>
            </div>

             <div class="row">

                            <div class="col-3 p-2"  @click="selectLocation('Business Address')" v-if="productToBeScheduled.Biz == 'Y'">
                                    <div class="cServicelocation" id="Business Address">
                                        <div class="cGridicon">
                                            <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/business.png" alt="" class="img-fluid">
                                        </div>
                                        <div class="cSlocationtxt pt-3">
                                            <p class="p-0 m-0">Business Address</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-3 p-2" @click="selectLocation('Home Address')" v-if="productToBeScheduled.Home == 'Y'">
                                    <div class="cServicelocation" id="Home Address">
                                        <div class="cGridicon">
                                            <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/home.png" class="img-fluid" alt="">
                                        </div>
                                        <div class="cSlocationtxt pt-3">
                                            <p class="p-0 m-0">Home Address</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-3 p-2" @click="selectLocation('Venue Address')" v-if="productToBeScheduled.Venue == 'Y'">
                                    <div class="cServicelocation" id="Venue Address">
                                        <div class="cGridicon">
                                            <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/outstation.png" class="img-fluid" alt="">
                                        </div>
                                        <div class="cSlocationtxt pt-3">
                                            <p class="p-0 m-0">Outstation</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-3 p-2" @click="selectLocation('Video Consultation')" >
                                    <div class="cServicelocation" id="Video Consultation">
                                        <div class="cGridicon">
                                            <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/video.png" class="img-fluid" alt="">
                                        </div>
                                        <div class="cSlocationtxt pt-3">
                                            <p class="p-0 m-0">Video Consultation</p>
                                        </div>
                                    </div>
                                </div>

        </div>

                    <div class="row mt-3">
                        <div class="col-md-12">
                            <p class="dr-day mb-0">Day</p>
                        </div>
                    </div>
                    <div class="scrolling-wrapper-flexbox text-center">
                        <div class="col-3 day-shedule m-1 cCursorhover active-day" v-for="days,index in weekdaysArray" :key="days.id" v-if="index == DayValue" v-bind:id="days" @click="daySelect(days)">
                            <a >
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="dr-time mb-0">Today, {{today}}</p>
                                        <p class="dr-slots mb-0"></p>
                                    </div>
                                </div>
                            </a>
                        </div>
                            
                             <div class="col-3 day-shedule m-1 cCursorhover" v-for="days,index in weekdaysArray" :key="days.id" v-if="index == (DayValue + 1)" v-bind:id="days" @click="daySelect(days)">
                            <a >
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="dr-time mb-0">Tomorrow</p>
                                        <p class="dr-slots mb-0"></p>
                                    </div>
                                </div>
                            </a>
                            </div>  

                            <div class="col-3 day-shedule m-1 cCursorhover" v-for="days,index in weekdaysArray" :key="days.id" v-if="index > (DayValue+1)" v-bind:id="days" @click="daySelect(days)">
                            <a >
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="dr-time mb-0">{{days}}</p>
                                        <p class="dr-slots mb-0"></p>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-3 day-shedule m-1 cCursorhover" v-for="days,index in weekdaysArray" :key="days.id" v-if="index < DayValue" v-bind:id="days" @click="daySelect(days)">
                            <a >
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="dr-time mb-0">{{days}}</p>
                                        <p class="dr-slots mb-0"></p>
                                    </div>
                                </div>
                            </a>
                        </div>
                        
                    </div>
                    <div class="row mt-3" v-if="shiftList.length != 0">
                        <div class="col-md-12">
                            <p class="dr-day mb-0">Shift</p>
                        </div>
                    </div>
                    <div class="row pl-3 text-center">
                        <div class="col-3 p-0 cCursorhover" v-for="shifts in shiftList" :key="shifts.id"  @click="shiftSelect(shifts)">
                            <div class="row m-1">
                                <div class="col-md-12 shift-day pt-2 pb-2 " v-bind:id="shifts.ShiftName">
                                    <a >{{shifts.ShiftName}}</a>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="row mt-3" v-if="slotList.length != 0">
                        <div class="col-md-12">
                            <p class="dr-day mb-0">Slot</p>
                        </div>
                    </div>
                    <div class="row pl-3 text-center" v-if="slotList.length != 0" >
                        <div class="col-3 align-self-center p-0 cCursorhover" v-for="slot in slotList" :key="slot.id" @click="slotSelect(slot)">
                            <div class="row m-1">
                                <div class="col-md-12 slot-time pt-2 pb-2" v-bind:id="slot.StartTime">
                                    <a >{{slot.StartTime}} - {{slot.EndTime}} </a>
                                </div>
                            </div>
                        </div>
                        
                    </div>

</div> 

<div class="w-75 ml-auto mr-auto" v-if="noSearchItem">
<img  src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/no-product.png" class="noProduct img-fluid">
</div>


   
   <div class="modal fade modal-add" id="shareProductsToMedia" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" style="width:50%;height:140px">
      <div class="modal-header">
        <h6 class="modal-title product-heading-modal" id="exampleModalLongTitle">Share Via -</h6>
        <button type="button" class="close add-more"  data-dismiss="modal" aria-label="Close">
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="modal-body" style="justify-content: center;display: flex;">
      <i style="font-size:40px;color:#3b5998" class="fab fa-facebook" @click='open("facebook")'></i>
      <i style="font-size:40px;margin-left:20px;color:#25D366" class="fab fa-whatsapp" @click='open("whatsapp")'></i>
      <i style="font-size:40px;margin-left:20px;color:#00acee" class="fab fa-twitter" @click='open("twitter")'></i>
      </div>
    </div>
  </div>
</div>
  
 <!-- Modal -->
<div class="modal bottom fade" id="categories" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog fixed-bottom m-0 mw-100" role="document">
        <div class="modal-content category-modal border-0 cScrollbar">
            <div class="modal-header">
            <h6><b class="cCategorytitle">All Categories</b></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body">
                <nav class="navbar side-nav-font" v-if="!store && !packageShow">
                    <ul class="navbar-nav w-100">
                        <li class="nav-item" v-for="item in category" :key="item.id">
                            <span v-for="catg in item[0].JSon0" :key="catg.id" v-bind:id="catg.CategoryID" data-dismiss="modal"><a class="nav-link"  @click="handleClick(catg.CategoryID,item[0].JSon0,catg.ServiceCategory)" data-toggle="collapse" v-bind:href="catg.ProductCategoryHandle | includeHash" v-bind:data-target="catg.ProductCategoryHandle | includeHash">{{catg.ServiceCategory}}</a>
                            <div class="collapse" v-bind:id="catg.SmartMediaHandle" aria-expanded="false">
                                <ul class="flex-column pl-2 nav cCursorhover" v-for="subcategory in subcategoryList" :key="subcategory.id">
                                    <li v-if="catg.ProdCategoryID === subcategory.ParentProductCategoryID" v-bind:id="subcategory.ParentProductCategoryID" @click="handleSubCategoryClick(subcategory)" class="nav-item"><a class="nav-link py-0" >{{subcategory.ProductCategory}}</a></li>
                                </ul>
                            </div>
                            <div class="dropdown-divider m-0"></div>
                            </span>
                        </li>
                        
                    </ul>
                </nav>
                <nav class="navbar side-nav-font" v-if="store && !packageShow">
                    <ul class="navbar-nav w-100">
                        <li class="nav-item" >
                            <span v-for="catg in categoryList" :key="catg.id" v-bind:id="catg.ProdCategoryID" data-dismiss="modal"><a class="nav-link"  @click="handleClick(catg.ProdCategoryID,categoryList,catg.ProductCategory)" data-toggle="collapse" v-bind:href="catg.ProductCategoryHandle | includeHash" v-bind:data-target="catg.ProductCategoryHandle | includeHash">{{catg.ProductCategory}}</a>
                            <div class="collapse" v-bind:id="catg.SmartMediaHandle" aria-expanded="false">
                                <ul class="flex-column pl-2 nav cCursorhover" v-for="subcategory in subcategoryList" :key="subcategory.id">
                                    <li v-if="catg.ProdCategoryID === subcategory.ParentProductCategoryID" v-bind:id="subcategory.ParentProductCategoryID" @click="handleSubCategoryClick(subcategory)" class="nav-item"><a class="nav-link py-0" >{{subcategory.ProductCategory}}</a></li>
                                </ul>
                            </div>
                            <div class="dropdown-divider m-0"></div>
                            </span>
                        </li>
                        
                    </ul>
                </nav>
                <nav class="navbar side-nav-font" v-if="!store && packageShow">
                    <ul class="navbar-nav w-100">
                        <li class="nav-item" >
                            <span v-for="catg in packageCategory" :key="catg.id" v-bind:id="catg.PkCatID" data-dismiss="modal"><a class="nav-link"  @click="handleClick(catg.PkCatID,packagesList,catg.PkCat)" data-toggle="collapse" v-bind:href="catg.ProductCategoryHandle | includeHash" v-bind:data-target="catg.ProductCategoryHandle | includeHash">{{catg.PkCat}}</a>
                            <div class="collapse" v-bind:id="catg.SmartMediaHandle" aria-expanded="false">
                                <ul class="flex-column pl-2 nav cCursorhover" v-for="subcategory in subcategoryList" :key="subcategory.id">
                                    <li v-if="catg.ProdCategoryID === subcategory.ParentProductCategoryID" v-bind:id="subcategory.ParentProductCategoryID" @click="handleSubCategoryClick(subcategory)" class="nav-item"><a class="nav-link py-0" >{{subcategory.ProductCategory}}</a></li>
                                </ul>
                            </div>
                            <div class="dropdown-divider m-0"></div>
                            </span>
                        </li>
                        
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</div>

<div v-if="FCProductModalItem != null" class="modal fade" id="comboModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered desktop-view text-left" role="document">
          <div class="modal-content">
               <div class="modal-header border-bottom-0">
                    <span class="modal-title modal-heading extra-bold-font mt-3" id="exampleModalLongTitle">{{FCProductModalItem.ProductName}}</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                         <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                    </button>
               </div>
               <div class="modal-body" >
                    <p class="custom-font-weight modal-details modal-font-size">{{FCProductModalItem.ProductDescription}}</p>
                    <span v-for="primary in FCPrimaryVariantList" :key="primary.id" v-if="primary.ProductHandle == FCProductModalItem.ProductHandle && primary.VariantType == 'P'" class="modal-font-size extra-bold-font"><b>{{primary.VariantName}}</b> ({{primary.VariantInstructions}})
                    <form>
                         <div class="row mt-2" v-for="primaryItems in FCItemList" :key="primaryItems.id" v-if="primaryItems.ProductVariantID == primary.ProductVariantID">
                              <div class="col-9">
                                   <span class="modal-font-size custom-font-weight list-font-color">{{primaryItems.VariantValue}}</span>
                              </div>
                              <div class="col-3 text-right">
                                   <label class="extra-bold-font modal-font-size mr-2" for="r1">{{FCProductModalItem.CurrencyText}} {{primaryItems.OfferPrice}}</label><input v-on:change="selectPrimaryVariant(primaryItems)" type='radio' name="foods" />
                              </div>
                         </div>
                         <div v-for="dependent in FCPrimaryVariantList" :key="dependent.id" v-if="dependent.ParentVariantID == primary.ProductVariantID && dependent.VariantType == 'D' && primaryClicked" class="modal-font-size extra-bold-font"><b>{{dependent.VariantName}}</b>  ({{dependent.VariantInstructions}})
                         <div class="row mt-2" v-for="secondaryItems in FCSecondaryItemList" :key="secondaryItems.id" v-if="secondaryItems.ProductVariantID == dependent.ProductVariantID && secondaryItems.PrimaryVariantValueID == selectedVariantId">
                              <div class="col-9">
                                   <span class="modal-font-size custom-font-weight list-font-color">{{secondaryItems.VariantValue}}</span>
                              </div>
                              <div class="col-3 text-right">
                                   <div class="row">
                                        <div class="col-9 pr-0">
                                             <label class="extra-bold-font modal-font-size mr-2" for="r1">{{FCProductModalItem.CurrencyText}} {{secondaryItems.OfferPrice}}</label>
                                        </div>
                                        <div class="col-3 pl-0">
                                             <div class="custom-control custom-checkbox" v-on:change="cartTotalFC(secondaryItems,'M','N')">
                                                  <input type="checkbox" class="custom-control-input" v-bind:id="secondaryItems.VariantValue">
                                                  <label class="custom-control-label checkbox-label" v-bind:for="secondaryItems.VariantValue"></label>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>

                        </div>
                        </form>
                        </span>

                    <span v-for="primary in FCPrimaryVariantList" :key="primary.id" v-if="primary.ProductHandle == FCProductModalItem.ProductHandle && primary.VariantType == 'O'" class="modal-font-size extra-bold-font"><b>{{primary.VariantName}}</b> ({{primary.VariantInstructions}})
                    <form>
                         <div class="row mt-2" v-for="primaryItems in FCItemList" :key="primaryItems.id" v-if="primaryItems.ProductVariantID == primary.ProductVariantID">
                              <div class="col-9">
                                   <span class="modal-font-size custom-font-weight list-font-color">{{primaryItems.VariantValue}}</span>
                              </div>
                              <div class="col-3 text-right">
                                   <label class="extra-bold-font modal-font-size mr-2" for="r1">{{FCProductModalItem.CurrencyText}} {{primaryItems.OfferPrice}}</label>
                                   <input v-if="primary.IsMandatory == 'N'" v-on:change="cartTotalFC(primaryItems,'O','N')" type='checkbox' name="foods" />
                                   <input v-if="primary.IsMandatory == 'Y'" v-on:change="cartTotalFC(primaryItems,'O','Y')" type='radio' name="foods" />

                              </div>
                         </div>
                         
                        </form>
                        </span>
                        
                         <div class="row">
                              <div class="col-md-12 modal-font-size mt-3">
                                   <a data-dismiss="modal" @click="addVariantstoCart(FCProductModalItem)" class="btn button-blue btn-block">
                                        <div class="row">
                                             <div class="col-6 text-left">
                                                  <span>Item Total {{FCProductModalItem.CurrencyText}} {{fullCommerceTotal}}</span>
                                             </div>
                                             <div class="col-6 text-right">
                                                  <span>ADD ITEM</span>
                                             </div>
                                        </div>
                                   </a>
                              </div>
                         </div>
                    
               </div>
          </div>
     </div>
</div>


<!-- Modal -->

<div v-if="productList != '' && !mobile" class="modal fade" id="variantModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content h-50">
            <div class="modal-body variant-scrollactive text-left modal-lg pl-3 pr-3 pt-0 pb-0">
                <div class="row variants-header">
                    <div class="col-md-2 align-self-center">
                        <img v-bind:src="productList.MediaURL" class="img-fluid p-2" style="border-radius:10px;">  
                    </div>
                    <div class="col-md-8 col-9 align-self-center">
                        <p class="variant-heading mb-0">
                        
                            {{productList.CompanyService}}
                        </p>
                        
                    </div>
                    <div class="col-md-2 col-3 pl-0 align-self-center text-right custom-text-color">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                        </button><br>
                        
                        <a data-toggle="modal" data-target="#shareProductsToMedia" class="share-icon cCursorhover"><i class="fas fa-share mr-2"></i>Share</a>
                    </div>
                </div>
                <div class="row pt-4 pl-2">
                    <div class="col-md-12" id="modalNav">
                        <nav class="tabbable"  id="scrollingnav">
                            <ul class="nav nav-tabs border-0 variants-tab">
                                <li class="nav-item"><a class="nav-link border-0 pl-0 cModalactive cCursorhover" id="MDescription" @click="handleModalScroll('Description')">Details</a></li>
                                <li  id="MVariant" class="nav-item cCursorhover"><a class="nav-link border-0" @click="handleModalScroll('Variant')">Add On Services</a></li>
                                
                            </ul>
                        </nav>
                    </div>
                    <div class="col-md-12 modal-accordion" data-spy="scroll" data-target="#scrollingnav" data-offset="150">
                        <div class="card border-0" id="Description">
                            <div class="card-header bg-white border-0" id="headingOne">
                                <p class="mb-0 custom-text-color dropdown-heading">
                                    <strong>Details</strong></span>
                                </p>
                            </div>
                            <div class="card-body">
                                <div class="row justify-content-center">
                                    <div class="col-md-6">
                                        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                                            

                                            <ol class="carousel-indicators">
                                                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                                            </ol>
                                                                

                                            <div class="carousel-inner" v-if="productList.MediaURL != '' && productList.MediaURL != null ">
                                                    <div class="carousel-item active">
                                                        <img class="d-block w-100 product-details-carousel" v-bind:src=productList.MediaURL alt="First slide">
                                            </div>
                                            
                                            <div class="carousel-item">
                                                <img class="d-block w-100 product-details-carousel" v-bind:src=productList.MediaURL alt="Second slide">
                                            </div>
                                            <div class="carousel-item">
                                                <img class="d-block w-100 product-details-carousel" v-bind:src=productList.MediaURL alt="Third slide">
                                            </div>
                                    
                                            </div>

                                            <div class="carousel-inner" v-if="productList.MediaURL == '' || productList.MediaURL == null ">
                                                <div class="carousel-item active">
                                                    <img class="d-block w-100 product-details-carousel" src="../assets/img/no_image.png" alt="First slide">
                                            </div>
                                            <div class="carousel-item">
                                                <img class="d-block w-100 product-details-carousel" src="../assets/img/no_image.png" alt="Second slide">
                                            </div>
                                            <div class="carousel-item">
                                                <img class="d-block w-100 product-details-carousel" src="../assets/img/no_image.png" alt="Third slide">
                                            </div>
                                   
                                            </div>

                                            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"><i class="fas fa-chevron-left text-dark"></i></span>
                                                <span class="sr-only">Previous</span>
                                            </a>
                                            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"><i class="fas fa-chevron-right text-dark"></i></span>
                                                <span class="sr-only">Next</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    
                                    <div class="col-md-12" >
                                        <strong id="OfferPrice">{{currency}} {{productList.OfferPrice}}</strong><del id="MRP" class="text-muted ml-2">{{currency}} {{productList.MRP}}</del>
                                    </div>
                                    
                                    <div class="col-md-12 mt-3">
                                        <ul class="variant-bottom-descriptation list-unstyled">
                                            <li>{{productList.ServiceDescription}}</li>
                                             
                                        </ul>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div class="card border-0" id="Variant" >
                            <div class="card-header bg-white border-0" id="headingOne">
                                <p class="mb-0 custom-text-color dropdown-heading">
                                    <strong>Add On Services</strong></span>
                                </p>
                            </div>
                            <div class="card-body">
                                <div class="row pl-3 pr-3">
                                    <div class="col-md-12" v-for="services in category" :key="services.id">
                                        <p class="product-size"><strong>Size</strong> (select one or multiple items)</p>
                                        <div class="row mt-3" v-for="type in services[0].JSon2" :key="type.id" v-if="type.ServiceID == productList.ServiceID">
                                            <div class="col-4 variant-quantity">
                                                <span>{{type.CompanyService}}</span>
                                            </div>
                                            <div class="col-4 variant-quantity text-center">
                                                <span class="text-dark mr-2">{{currency}} {{type.OfferPrice}}</span>
                                                <del class="product-price-del">{{currency}} {{type.MRP}}</del>
                                            </div>
                                            
                                         
                                            <input  type='checkbox' v-on:change="Addservices(type,productList)" name="foods" />
                                   

                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                         
                    </div>
                </div>

                <div @click="addListToCart()" data-dismiss="modal" class="card-footer border-0 bg-white footer-shadow mt-3 row add-cart">
                    <div class="col-md-12 footer">
                        <span >Item Total {{productList.CurrencyText}} {{modalTotalCount | total}}</span><span  class="float-right cAdditemmodel cCursorhover">ADD ITEM</span>
                    </div>
                </div>

               

            </div>
        </div>
    </div>
</div>

<div class="modal fade login show" id="repeatItem" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body pr-4 pl-4 pb-4">
                <div class="mt-2">
                    <b>Would you like to add new item with same customization or you'll like to change?</b>
                </div>

                <div class="row pt-4 pb-4">
                <div data-dismiss="modal" @click="repeatSelectedItem()" class="col-md-6 cCursorhover">
                    <a style="color:black;">REPEAT</a>
                </div>
                <div data-dismiss="modal" @click="chooseAgain()" class="col-md-6 cCursorhover">
                    <a  style="color:red;">I'll CHOOSE</a>
                </div>
                </div>
            </div>

        </div>
    </div>
</div>
</div>

 <div class="col-md-9 border-left border-right pt-3" v-if="roomBoolean">
                    <p class="font20 font500 mb-0">Check price and availability </p> 
                    <div class="row">
                        <div class="col-md-6 mt-3">
                            <div class="card greenLeftBorder border-0 cardShadow">
                                <div class="card-body p-2">
                                    <div class="row">
                                        <div class="col-3 col-md-4 col-lg-3 text-center align-self-center">
                                            <img src="../assets/img/hotel/Vector.svg" />
                                        </div>
                                        <div class="col-9 col-md-8 col-lg-9 align-self-center pl-0">
                                            <p class="font14 colorLightGray mb-0">Check In</p>
                                            <p class="darkBlackText font16 font500 mb-0">Tue, 24/08/21</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mt-3">
                            <div class="card redLeftBorder border-0 cardShadow">
                                <div class="card-body p-2">
                                    <div class="row">
                                        <div class="col-3 col-md-4 col-lg-3 text-center align-self-center">
                                            <img src="../assets/img/hotel/Vector.svg" />
                                        </div>
                                        <div class="col-9 col-md-8 col-lg-9 align-self-center pl-0">
                                            <p class="font14 colorLightGray mb-0">Check Out</p>
                                            <p class="darkBlackText font16 font500 mb-0">Wed, 25/08/21</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-3">
                            <div class="card border-0 cardShadow">
                                <div class="card-body p-2 dropdown">
                                    <div class="row" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <div class="col-2 text-center align-self-center">
                                            <img src="../assets/img/hotel/Vector (6).svg" />
                                        </div>
                                        <div class="col-10 align-self-center pl-0">
                                            <p class="font14 colorLightGray mb-0">Guests</p>
                                            <p class="darkBlackText font16 font500 mb-0">1 room, 2 adults, 0 children</p>
                                        </div>
                                    </div>
                                    <div class="dropdown-menu text-center cardShadow customDropdown borderRadius5 border-0 dropdown-menu-right mr-1" onclick="event.stopPropagation()" aria-labelledby="triggerId">
                                        <a class="dropdown-item mt-2">
                                            <p class="font15 font500 mb-2 text-left">Room</p>
                                            <button class="btn btn-sm quantity-increment text-white incDecBtn bgYellow">+</button>
                                            <button class="btn btn-sm product-quantity bg-white fixed-width">1</button>
                                            <button class="qantity-decrement text-white btn btn-sm incDecBtn bgYellow">-</button>
                                        </a>
                                        <a class="dropdown-item mt-3">
                                            <p class="font15 font500 mb-2 text-left">Adult</p>
                                            <button class="btn btn-sm quantity-increment text-white incDecBtn bgYellow">+</button>
                                            <button class="btn btn-sm product-quantity bg-white fixed-width">2</button>
                                            <button class="qantity-decrement text-white btn btn-sm incDecBtn bgYellow">-</button>
                                        </a>
                                        <a class="dropdown-item mt-3">
                                            <p class="font15 font500 mb-2 text-left">Children</p>
                                            <button class="btn btn-sm quantity-increment text-white incDecBtn bgYellow">+</button>
                                            <button class="btn btn-sm product-quantity bg-white fixed-width">0</button>
                                            <button class="qantity-decrement text-white btn btn-sm incDecBtn bgYellow">-</button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-3">
                            <button class="btn btn-block btn-lg bgYellow text-white font600 font14 pt-2 pb-2">CHECK AVAILABILITY</button>
                        </div>
                    </div>
                    <p class="font20 font500 mb-0 mt-3">Select Room</p> 
                    <div class="row">
                        <div class="col-md-12 mt-3 mb-3" v-for="rooms in hotelList">
                            <div class="Card cardShadow border-0 borderRadius5">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12 col-lg-4">
                                            <img v-bind:src="JSON.parse(rooms.MediaJSon).MediaURL" class="w-100"/>
                                        </div>
                                        <div class="col-md-12 col-lg-8">
                                            <p class="font20 font500 mb-0">{{rooms.Resource}}</p>
                                            <p class="font16 textColor mt-4">{{rooms.ResourceDescription}}</p> 
                                            <div class="row">
                                                <div class="col-md-6" v-for="resources in hotelresourceList" :key="resources.id" v-if="rooms.ResourceID == resources.BusinessResourceID">
                                                    <p class="mb-0 textColor font14">{{resources.AttributeName}}: {{resources.AttributeValue}}</p>
                                                </div>
                                                
                                            </div>
                                            <hr/>
                                            <div class="row mt-3">
                                                <div class="col-6 align-self-center">
                                                    <p class="font16 font600 mb-0"><span class="textColor">{{currency}}{{rooms.BookingAmount}}</span>  {{currency}}{{rooms.PricingStatement}}</p>
                                                </div>
                                                <div class="col-6 align-self-center">
                                                    <button class="btn btn-block btn-lg bgYellow font14 text-white font600 pt-2 pb-2">Book</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
</div>
<!-- eslint-enable -->

</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  
  name:"Category",
  components:{
      Loading
  },
  data : function() {
      return {
        listItems : [],
        filterlist : [],
        grid : false,
        imgUrl : '../assets/img/svg/Icon_open-grid-three-up.svg',
        searchValue : '',
        searchList : [],
        itemObj : {
            name : '',
            price : null
        },
        itemList : [],
        categoryList: [],
        categoryCopyList :[],
        productList : [],
        selectedVariantList : [],
        modalItemList :[],
        modalTotalCount : 0,
        variantList :[],
        isLoading: false,
        fullPage: true,
        loader:'Spinner',
        homeDeliveryActive:true,
        takeAwayActive : false,
        productDetail : null,
        scrollList : [],
        scrollHeight : 0,
        scrollCount : 0,
        activeElement : 'Service & Bookings',
        currency:'',
        clicked : false,
        subcategoryList : [],
        setItemSelected : false,
        easyCommerce : true,
        FCPrimaryVariantList : [],
        FCProductModalItem : [],
        FCItemList : [],
        FCSecondaryItemList : [],
        primaryClicked : false,
        selectedVariantId : '',
        fullCommerceTotal : 0,
        variantsTypeSelected : [],
        fullCommerceVariantList : [],
        mobile : false,
        variantSelecetedList : [],
        primaryVvid : '',
        noSearchItem : false,
        variantNameCheck : '',
        productToCustomize : null,
        viewUpdated : true,
        defaultSelect : false,
        store : false,
        packagesList : [],
        packageShow : false,
        packageCategory : '',
        searchPlaceholder : 'Search Services',
        bookSlotBoolean : false,
        today : '',
        DayValue : 0,
        currentDate : '',
        weekdaysArray : ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
        tomorrow : '',
        shift : [],
        shiftList : [],
        slotList : [],
        slots : [],
        productToBeScheduled : '',
        itemAddedBoolean : false,
        timeStatement : 'Thursday',
        editSlotValue : '',
        modalScrollList : ["Description","Variant","Deliver","Customizations"],
        modalScrollMobileList : ["DescriptionMobile","VariantMobile","DeliverMobile","CustomizationsMobile"],
        addOnServiceList : [],
        serviceLocation : 'Business Address',
        roomBoolean : false,
        locationList : ['Business Address',"Home Address","Venue Address","Video Consultation"],
        hotelList : [],
        hotelresourceList : []
      }
  },

    filters :{
        subStr : function(string){
            if(string.includes(':')){
                
                return string.split(':')[1].split('"')[1]
            }
            return string.split("'")[1];
        },
        variant : function(string){
            return string.split(':')[1].split('"')[1]
        },
        increment : function(string){
            
            return string + "I";
        },
        newVariant: function(string){
           
            return string + "V";
        },
        nameLength: function(string){
            // if(string.length > 25){
            //     return string.substring(0,25) + '...'
            // }
            return string
        },
        productQuantity: function(string){
            return string + "productQuantity";
        },
        total : function(number){
            return number.toFixed(2)
        },
        includeHash : function(string){
            return '#' + string
        },
        descLength : function(string){
            if(string != '' && string != null){
                if(string.length > 100){
                return string.substring(0,100) 
            }
                return string
            } 
        },
        readmore : function(string){
            return string + "rm"
        },
        readless : function(string){
            return string + "rl"
        }
    },
      computed:{
      category() {
        return this.$store.state.category
      },
      items() {
        return this.$store.state.items
      }
    },
    created(){
        if(screen.width <= 760) {
                this.mobile = true
            }
        else{
                this.mobile = false
            }
    },
    // destroyed(){
    //     window.removeEventListener('scroll',this.handleItemSelect);
    // },
    updated: function(){
        this.$nextTick(function(){

            if(!this.viewUpdated){
            if(this.productList.length != 0){
            for(var i =0;i<this.selectedVariantList.length;i++){
                        
                        document.getElementById(this.selectedVariantList[i].Variants+"V").style.display = 'block'
                        document.getElementById(this.selectedVariantList[i].Variants+"I").style.display = 'none'
                    }
            }

           
            if(this.itemList.length != 0){
                for(var j =0;j<this.selectedVariantList.length;j++){
                 for(var k =0;k<this.itemList.length;k++){
                     if(this.itemList[k].name == this.productList.ProductName && this.itemList[k].variant == this.selectedVariantList[j].Variants){
                            if(this.itemList[k].quantity != 0){
                            document.getElementById(this.selectedVariantList[j].Variants+"V").style.display = 'none'
                            document.getElementById(this.selectedVariantList[j].Variants+"I").style.display = 'block'
                            this.modalTotalCount = this.modalTotalCount + (this.itemList[k].cost*this.itemList[k].quantity);
                            document.getElementById(this.selectedVariantList[j].Variants).value = this.itemList[k].quantity
                            }
                        }
                 }
            }
            }
            else{
                for(var z =0;z<this.selectedVariantList.length;z++){
                        document.getElementById(this.selectedVariantList[z].Variants+"V").style.display = 'block'
                        document.getElementById(this.selectedVariantList[z].Variants+"I").style.display = 'none'
                    }
            }
            this.viewUpdated = true;
            }

             
            
            // if(!this.defaultSelect){
                    
            //         for(var y =0;y<this.itemList.length;y++){
                        
            //             if(this.itemList[y].VID != ''){
            //                 if(!this.modalItemList.includes(this.itemList[y])){
            //                     this.modalItemList.push(this.itemList[y])
            //                     document.getElementById(this.itemList[y].ProductHandle + 'I').style.display = 'none'
            //                     document.getElementById(this.itemList[y].productHandle + 'V').style.display = 'block'
            //                 }
            //             }
            //             else{
            //                 document.getElementById(this.itemList[y].productHandle + 'I').style.display = 'none'
            //                 document.getElementById(this.itemList[y].productHandle + 'V').style.display = 'block'
            //                 document.getElementById(this.itemList[y].productHandle + 'productQuantity').value = this.itemList[y].quantity
            //             }
            //         }
            //         this.defaultSelect = true;
            // }
            
            if(this.itemAddedBoolean){
                for(var m=0;m<this.itemList.length;m++){
                        if(document.getElementById(this.itemList[m].productHandle+'V') != null){
                            document.getElementById(this.itemList[m].productHandle+'V').style.display = 'block'
                            document.getElementById(this.itemList[m].productHandle + 'I').style.display = 'none'
                        }
                    
                }
                
            }
            
         })
    },
    mounted(){
            
            this.currentDate = new Date().toString().substring(0,3);
            this.today = (new Date()).toString().substring(4,11);
            this.DayValue = new Date().getDay();
            console.log(this.DayValue)
            

            if(sessionStorage.getItem('RouteHandle') != this.$route.params.handle){
                
                sessionStorage.removeItem('StoreBranches')
                this.getBranchHandle();
            }
            else{
                 this.$store.dispatch('loadItems')
                 this.openServices();
                if(sessionStorage.getItem('StoreBranches') != null){
                    if(JSON.parse(sessionStorage.getItem('StoreBranches')).length > 1){
                        this.$root.$emit('boolean',true)
                    }
                    else{
                        this.$root.$emit('boolean',false)
                    }

                }
                
                    if(sessionStorage.getItem('ECommDS') == 'EASYCOMM1'){
                        this.easyCommerce = true
                    }
                    else if(sessionStorage.getItem('ECommDS') == 'ECOMM2' || sessionStorage.getItem('ECommDS') == 'ecomm2'){
                        this.easyCommerce = false
                    }
            }
            sessionStorage.setItem('RouteHandle',this.$route.params.handle)
            if(sessionStorage.getItem(this.$route.params.handle) != null){
                this.itemList = JSON.parse(sessionStorage.getItem(this.$route.params.handle))
            }
    
       
            
            this.$root.$on('Store',() =>{
                this.bookSlotBoolean = false;
                this.store = true;
                this.packageShow = false;
                this.roomBoolean = false
                this.activeElement = "All Products"
                this.searchPlaceholder = "Search Products"
                this.openStore()

                if(this.itemList.length != 0){
                for(var i=0;i<this.listItems.length;i++){
                    for(var j=0;j<this.itemList.length;j++){
                        if(this.itemList[j].productHandle == this.listItems[i].ProductHandle){
                            document.getElementById(this.itemList[j].productHandle+'V').style.display = 'block'
                            document.getElementById(this.itemList[j].productHandle + 'I').style.display = 'none'
                            document.getElementById(this.itemList[j].productHandle+'productQuantity').value = 1
                        }
                        else{
                            document.getElementById(this.itemList[j].productHandle+'V').style.display = 'none'
                            document.getElementById(this.itemList[j].productHandle + 'I').style.display = 'block'
                        }
                    }
                }
                }
            })
            this.$root.$on('Rooms',() =>{
                this.roomBoolean = true
                
            })
            this.$root.$on('slotBooking',(value,name) =>{
                this.bookSlotBoolean = value
                this.editSlotValue = name
            })
            this.$root.$on('Services',() =>{
                this.bookSlotBoolean = false;
                this.store = false;
                this.packageShow = false;
                this.roomBoolean = false
                this.activeElement = "Service & Bookings"
                this.searchPlaceholder = "Search Services"
                this.openServices()

                if(this.itemList.length != 0){
                for(var i=0;i<this.listItems.length;i++){
                    for(var j=0;j<this.itemList.length;j++){
                        if(this.itemList[j].productHandle == this.listItems[i].ServiceID){
                            document.getElementById(this.itemList[j].productHandle+'V').style.display = 'block'
                            document.getElementById(this.itemList[j].productHandle + 'I').style.display = 'none'
                        }
                        else{
                            document.getElementById(this.itemList[j].productHandle+'V').style.display = 'none'
                            document.getElementById(this.itemList[j].productHandle + 'I').style.display = 'block'
                        }
                    }
                }
                }
            })
            this.$root.$on('Packages',() =>{
                this.bookSlotBoolean = false;
                this.store = false;
                this.packageShow = true;
                this.roomBoolean = false;
                this.activeElement = "Packages & More"
                this.searchPlaceholder = "Search Packages"
                this.openServices()

                if(this.itemList.length != 0){
                    for(var i=0;i<this.packagesList.length;i++){
                    for(var j=0;j<this.itemList.length;j++){
                        if(this.itemList[j].productHandle == this.packagesList[i].PackageHandle){
                            document.getElementById(this.itemList[i].productHandle+'V').style.display = 'block'
                            document.getElementById(this.itemList[i].productHandle + 'I').style.display = 'none'
                        }
                        else{
                            document.getElementById(this.itemList[i].productHandle+'V').style.display = 'none'
                            document.getElementById(this.itemList[i].productHandle + 'I').style.display = 'block'
                        }
                    }
                }
                }
                
            })

            this.$root.$on('cartListChanges',(cartList) =>{
            
            this.itemList = [];
            this.itemList = cartList;

            console.log(cartList)
            console.log(this.itemList)
                for(var i=0;i<cartList.length;i++){
                if(this.itemList.some(data => data.name === cartList[i].name)){
                    if(cartList[i].quantity == 0 && cartList[i].VID == ''){
                        document.getElementById(cartList[i].productHandle + "V").style.display = 'none'
                        document.getElementById(cartList[i].productHandle + "I").style.display = 'block'
                    }
                    document.getElementById(cartList[i].productHandle + "productQuantity").value = cartList[i].quantity
                    }
                }
            

            if(cartList.length == 0){
                this.itemList = [];
                this.modalItemList = [];
                sessionStorage.removeItem(this.$route.params.handle)
            }

            })
            },
    
    methods: {
        updateScroll:function(){
        
        if(this.store && !this.packageShow){
        if(this.clicked == true){
            this.clicked = false
            return;
        }
        else{
             if(this.scrollCount == 0){
              for(var i=0;i<this.categoryList.length;i++){
               const el = document.getElementById(this.categoryList[i].ProductCategory)
               this.scrollHeight = this.scrollHeight + el.scrollHeight
               this.scrollList.push({name:this.categoryList[i].ProductCategory,height:this.scrollHeight,id:this.categoryList[i].ProdCategoryID})
               this.scrollCount = this.scrollCount + 1;
           }
        }

         const el = document.querySelector(".scroll")
         if(el.scrollTop == 0){
             if(this.store){
                 this.activeElement = 'All Products'
             }
             else if(this.packageShow){
                  this.activeElement = 'Pakages $ More'
             }
             else if(!this.store && !this.packageShow)
                this.activeElement = 'Service $ Bookings'
             return
         }
          for(var j=0;j<this.scrollList.length;j++){
              if(el.scrollTop < this.scrollList[j].height + 80){
                  this.activeElement = this.scrollList[j].name
                  return
              }
          }
        }
           
        }
        },

        Addservices: function(service){
            console.log(service)
            if(this.addOnServiceList.includes(service)){
                const index = this.addOnServiceList.indexOf(service)
                this.addOnServiceList.splice(index,1)
                this.modalTotalCount = this.modalTotalCount - service.OfferPrice
            }
            else{
                this.addOnServiceList.push(service)
                this.modalTotalCount = this.modalTotalCount + service.OfferPrice
            }
            
        },
        readMore: function(handle){
            document.getElementById(handle + 'rm').style.display = 'none'
            document.getElementById(handle + 'rl').style.display = 'block'
        },
        readLess: function(handle){
            document.getElementById(handle + 'rm').style.display = 'block'
            document.getElementById(handle + 'rl').style.display = 'none'
        },
        handleClick: function(text,loop,name) {

            if(this.bookSlotBoolean == true){
                this.bookSlotBoolean = false
                return
            }
            
            this.activeElement =''
            this.clicked = true
            const el = document.getElementById(name)
            el.scrollIntoView()
            if(!this.store && !this.packageShow){
            if(loop[loop.length-1].ServiceCategory != name){
                
                const scrollToCategory = document.getElementById('categoryHeader')
                scrollToCategory.scrollIntoView();
            }
            
            
            for(var i=0;i<loop.length;i++){
                if(text == loop[i].CategoryID){
                    document.getElementById(text).classList.add('active-menu')
                }
                else{
                    document.getElementById(loop[i].CategoryID).classList.remove('active-menu')
                }
            }
            }

            if(this.store && !this.packageShow){
            if(loop[loop.length-1].ProdCategory != name){
                
                const scrollToCategory = document.getElementById('categoryHeader')
                scrollToCategory.scrollIntoView();
            }
            
            
            for(var j=0;j<loop.length;j++){
                if(text == loop[j].ProdCategoryID){
                    document.getElementById(text).classList.add('active-menu')
                }
                else{
                    document.getElementById(loop[j].ProdCategoryID).classList.remove('active-menu')
                }
            }
            }

            if(!this.store && this.packageShow){
            if(loop[loop.length-1].PkCat != name){
                
                const scrollToCategory = document.getElementById('categoryHeader')
                scrollToCategory.scrollIntoView();
            }
            
            
            for(var k=0;k<loop.length;k++){
                if(text == loop[k].PkCatID){
                    document.getElementById(text).classList.add('active-menu')
                }
                else{
                    document.getElementById(loop[k].PkCatID).classList.remove('active-menu')
                }
            }
            }
            
        },
        selectLocation: function(location){
            this.serviceLocation = location
            document.getElementById(location).classList.add("cServiceClick")
            for(var i=0;i<this.locationList.length;i++){
                if(this.locationList[i] != location){
                    if(document.getElementById(this.locationList[i]) != null){
                        document.getElementById(this.locationList[i]).classList.remove("cServiceClick")
                    }
                    
                }

            }
            
        },
        handleItemSelect: function(){
        if(this.setItemSelected == false){
        if(sessionStorage.getItem(this.$route.params.handle) != null){
            var sessionStorageItemList = JSON.parse(sessionStorage.getItem(this.$route.params.handle))
            for(var i=0;i<sessionStorageItemList.length;i++){
            if(sessionStorageItemList[i].variant != ''){
            for(var j=0;j<this.listItems.length;j++){
                if(this.listItems[j].ProductName == sessionStorageItemList[i].name){
                    this.productList = this.listItems[j]
                    this.modalItemList.push(sessionStorageItemList[i])
                    document.getElementById(sessionStorageItemList[i].variant+'V').style.display = 'none'
                    document.getElementById(sessionStorageItemList[i].variant + 'I').style.display = 'block'
                }
            }
            }
            else{
            document.getElementById(sessionStorageItemList[i].name+'V').style.display = 'block'
            document.getElementById(sessionStorageItemList[i].name + 'I').style.display = 'none'
            document.getElementById(sessionStorageItemList[i].name+'productQuantity').value = sessionStorageItemList[i].quantity
            }
            }
            this.setItemSelected = true;
            this.itemList = sessionStorageItemList
            this.$root.$emit('ItemSelected',this.itemList)
        }
        }   
            
        },
        handleSubCategoryClick: function(subcategory){
            
            const val = document.getElementById(subcategory.ProdCategoryID)
            val.scrollIntoView()
             const scrollToCategory = document.getElementById('categoryHeader')
            scrollToCategory.scrollIntoView();
        },
        toggle : function(){
            if(this.grid == true){
                this.grid =false
            }
            else{
                this.grid =true;

            }
        },
        getBranchHandle: function(){
             this.isLoading = true;


        axios
                .post('https://entityserver.manikworks.com/bookmgr',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Content-Type': 'application/json',
                        'EntityActionType': 'GET.STORE.OUTLETS',
                        'BusinessHandle': this.$route.params.handle,
                    }
                })
                .then((response) =>{
                   
                    
                    if(response.data.ManikJSon[0].JSon0.length == 1){
                        sessionStorage.setItem('ECommDS',response.data.ManikJSon[0].JSon0[0].ECommDS);
                        sessionStorage.setItem('handle',response.data.ManikJSon[0].JSon0[0].BranchHandle);
                        sessionStorage.removeItem('Scratchhandle')
                    }
                    else{
                        
                        sessionStorage.setItem('ECommDS',response.data.ManikJSon[0].JSon0[0].ECommDS);
                        sessionStorage.setItem('handle',response.data.ManikJSon[0].JSon0[0].BranchHandle);
                        sessionStorage.setItem('Scratchhandle',response.data.ManikJSon[0].JSon0[0].BranchHandle);
                    }

                    if(sessionStorage.getItem('ECommDS') == 'EASYCOMM1'){
                        this.easyCommerce = true
                    }
                    else if(sessionStorage.getItem('ECommDS') == 'ECOMM2' || sessionStorage.getItem('ECommDS') == 'ecomm2'){
                        this.easyCommerce = false
                    }
                    
                    sessionStorage.setItem('StoreBranches',JSON.stringify(response.data.ManikJSon[0].JSon0))
                    if(response.data.ManikJSon[0].JSon0.length > 1){
                        this.$root.$emit('boolean',true)
                    }
                    else{
                        this.$root.$emit('boolean',false)
                    }

                    this.$store.dispatch('loadItems')
                    this.openServices();
                })
                
                .catch(() =>{
                    this.isLoading = false;
                })
        },
        search:function(event){
            this.searchValue = event.target.value
            if(event.target.value != ''){
                this.listItems =[]
                this.categoryList = [];
            for(var i=0;i<this.filterlist.length;i++){
                if(!this.store && !this.packageShow){
                if(this.filterlist[i].CompanyService.toLowerCase().includes(event.target.value.toLowerCase())){
                    this.listItems.push(this.filterlist[i])
                    for(var k=0;k<this.categoryCopyList.length;k++){
                        for(var z=0;z<this.listItems.length;z++){
                            
                            if(this.categoryCopyList[k].CategoryID == this.listItems[z].CategoryID){
                                if(!this.categoryList.includes(this.categoryCopyList[k])){
                                    this.categoryList.push(this.categoryCopyList[k])
                                }
                                
                            }
                        }
                    }
                }
            }
            else if(this.store && !this.packageShow){
                if(this.filterlist[i].SearchText.toLowerCase().includes(event.target.value.toLowerCase())){
                    this.listItems.push(this.filterlist[i])
                    for(var x=0;x<this.categoryCopyList.length;x++){
                        for(var y=0;y<this.listItems.length;y++){
                            
                            if(this.categoryCopyList[x].ProdCategoryID == this.listItems[y].ProductCategoryID){
                                if(!this.categoryList.includes(this.categoryCopyList[x])){
                                    this.categoryList.push(this.categoryCopyList[x])
                                }
                                
                            }
                        }
                    }
                }
            }
            
            }
            if(!this.store && this.packageShow){
                this.filterlist = this.packagesList
                this.categoryCopyList = this.packageCategory
                this.packagesList = []
                this.packageCategory = []
            for(var a=0;a<this.filterlist.length;a++){
                 if(this.filterlist[a].PackageName.toLowerCase().includes(event.target.value.toLowerCase())){
                    this.packagesList.push(this.filterlist[a])
                    for(var u=0;u<this.categoryCopyList.length;u++){
                        for(var v=0;v<this.packagesList.length;v++){
                            
                            if(this.categoryCopyList[u].PkCatID == this.packagesList[v].PkCatID){
                                if(!this.packageCategory.includes(this.categoryCopyList[u])){
                                    this.packageCategory.push(this.categoryCopyList[u])
                                }
                                
                            }
                        }
                    }
                }
            }
            }
            if(this.listItems.length == 0 && !this.packageShow){
                this.noSearchItem = true
            }
            else{
                this.noSearchItem = false
            }
            }else{
                this.noSearchItem = false;
                this.listItems = this.filterlist
                this.categoryList = this.categoryCopyList
            }
            
        },

        bookSlots: function(product){
            console.log(product)
            this.bookSlotBoolean = true;
            this.productToBeScheduled = product
            this.slotList = []
        },
        handleModalScroll: function(type){
            const el = document.getElementById(type)
            el.scrollIntoView()
        if(!this.mobile){
             for(var i=0;i<this.modalScrollList.length;i++){
            
                if(type == this.modalScrollList[i]){
                    
                    document.getElementById("M" + type).classList.add('cModalactive')
                }
                else{
                    if(document.getElementById("M" + this.modalScrollList[i]) != null){
                    document.getElementById("M" + this.modalScrollList[i]).classList.remove('cModalactive')
                    }
                }
            }
        }
        else{  
            for(var j=0;j<this.modalScrollMobileList.length;j++){
                if(type == this.modalScrollMobileList[j]){
                    document.getElementById("M" + type).classList.add('cModalactive')
                }
                else{
                    document.getElementById("M" + this.modalScrollMobileList[j]).classList.remove('cModalactive')
                }
            }
        }
           

        },
        addItem : function(product){
            console.log(this.serviceLocation)
            if(!this.store && !this.packageShow){
            // document.getElementById(product.ServiceID+'V').style.display = 'block'
            // document.getElementById(product.ServiceID + 'I').style.display = 'none'
            for(var i=0;i<this.itemList.length;i++){
                if(this.itemList[i].ServiceID == product.ServiceID){
                    return
                }
            }
            this.itemList.push({name:product.CompanyService,cost:Number(product.OfferPrice),quantity:1,variant:0,currency:this.currency,BH:new Date().getTime(),VID:'',productHandle:product.ServiceHandle,PLID:0,timeStatement:this.timeStatement,location:this.serviceLocation,typeOfProduct:'service'})
            this.$root.$emit('ItemSelected',this.itemList)
            }

            if(this.store && !this.packageShow){
            document.getElementById(product.ProductHandle+'V').style.display = 'block'
            document.getElementById(product.ProductHandle + 'I').style.display = 'none'
            document.getElementById(product.ProductHandle+'productQuantity').value = 1
            for(var j=0;j<this.itemList.length;j++){
                if(this.itemList[j].productHandle == product.productHandle){
                    return
                }
            }
            this.itemList.push({name:product.ProductName,cost:Number(product.OfferPrice),quantity:1,variant:0,currency:this.currency,BH:new Date().getTime(),VID:'',productHandle:product.ProductHandle,PLID:product.BranchPriceListID,timeStatement:'',location:'',typeOfProduct:'store'})
            this.$root.$emit('ItemSelected',this.itemList)
            }

            if(!this.store &&this.packageShow){
            // document.getElementById(product.PackageHandle+'V').style.display = 'block'
            // document.getElementById(product.PackageHandle + 'I').style.display = 'none'
            // document.getElementById(product.PackageHandle+'productQuantity').value = 1
            for(var k=0;k<this.itemList.length;k++){
                if(this.itemList[k].productHandle == product.PackageHandle){
                    return
                }
            }
            this.itemList.push({name:product.PackageName,cost:Number(product.Price),quantity:1,variant:0,currency:this.currency,BH:new Date().getTime(),VID:'',productHandle:product.PackageHandle,PLID:product.BranchPriceListID,timeStatement:this.timeStatement,location:this.serviceLocation,typeOfProduct:'package'})
            this.$root.$emit('ItemSelected',this.itemList)
            }
        },
        openVariantModal: function(product){
            if(this.productList.ServiceID != product.ServiceID){
                this.addOnServiceList = []
            }
            this.productList = product
            this.modalTotalCount = product.OfferPrice;
        },
        sendInfo: function(product,variantNewList){
            this.productList = product;
            this.selectedVariantList = variantNewList
            this.modalTotalCount = 0;
            
            this.viewUpdated = false; 
        },
        backToListing: function(){
            this.bookSlotBoolean = false
        },
        selectListingType: function(type){
            this.$root.$emit(type)
        },
        openServices: function(){
                this.$store.dispatch('loadCategory')

                 axios
                .post('https://entityserver.manikworks.com/bookmgr',null,{
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Content-Type': 'application/json',
                        'EntityActionType': 'FETCH.OUTLET.CATALOG',
                        'OutletHandle': sessionStorage.getItem('handle'),
                        'BookDS': 'BOOKING2',
                        'Channel': 'WEB',
                        'Latitude': '32',
                        'Longitude': '12',
                        'CountryID': '100000',
                        'CitizenHandle': 'aaa-asasa'
                    }
                })
                .then((response) =>{
                console.log(response)
                this.packagesList = [];
                this.categoryList = response.data.ManikJSon[0].JSon0
                this.listItems =  response.data.ManikJSon[0].JSon1
                this.subcategoryList = response.data.ManikJSon[0].JSon1
                this.packagesList = response.data.ManikJSon[0].JSon3
                this.packageCategory = response.data.ManikJSon[0].JSon10
                this.hotelList = response.data.ManikJSon[0].JSon7
                this.hotelresourceList = response.data.ManikJSon[0].JSon12
                this.shift = response.data.ManikJSon[0].JSon5
                this.slots = response.data.ManikJSon[0].JSon6
                this.filterlist = this.listItems
                this.categoryCopyList = this.categoryList
                if(this.easyCommerce){
                    this.variantList=response.data.ManikJSon[0].JSon5
                }
                else{
                    this.FCPrimaryVariantList=response.data.ManikJSon[0].JSon6
                    this.FCItemList= response.data.ManikJSon[0].JSon7
                    this.FCSecondaryItemList = response.data.ManikJSon[0].JSon8
                }
                    
               
                this.$root.$emit('currency',this.listItems[0].CurrencyText)
                this.shiftList = []
                for(var j=0;j<this.shift.length;j++){
                if(this.shift[j].Thu == 'Y'){
                    this.shiftList.push(this.shift[j])
                   
                }
            }
                this.currency = sessionStorage.getItem("currency")
                 this.isLoading = false;
                
                })
                .catch(() =>{
                    this.isLoading = false;
                })
        },

        openStore: function(){
             axios
                .post('https://entityserver.manikworks.com/storemgr',null,{
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Content-Type': 'application/json',
                        'EntityActionType': 'FETCH.OUTLET.CATALOG',
                        'BranchHandle': sessionStorage.getItem('StoreBranchHandle'),
                        'ECommDS': sessionStorage.getItem('ECommDS'),
                        'Channel': 'WEB',
                        'Latitude': '32',
                        'Longitude': '12',
                        'CountryID': '100000',
                        'CitizenHandle': 'aaa-asasa'
                    }
                })
                .then((response) =>{
                console.log(response)
                this.categoryList = response.data.ManikJSon[0].JSon0
                this.listItems =  response.data.ManikJSon[0].JSon4
                this.subcategoryList = response.data.ManikJSon[0].JSon1
                this.isLoading = false;
                this.filterlist = this.listItems
                this.categoryCopyList = this.categoryList
                if(this.easyCommerce){
                    this.variantList=response.data.ManikJSon[0].JSon5
                }
                else{
                    this.FCPrimaryVariantList=response.data.ManikJSon[0].JSon6
                    this.FCItemList= response.data.ManikJSon[0].JSon7
                    this.FCSecondaryItemList = response.data.ManikJSon[0].JSon8
                }
                    
               
                this.$root.$emit('currency',this.listItems[0].CurrencyText)
                if(this.listItems[0].CurrencyText != null){
                    sessionStorage.setItem('currency',this.listItems[0].CurrencyText)
                }
                
               
                
                })
                .catch(() =>{
                    this.isLoading = false;
                })
        },
       
        FCsendInfo: function(product){
            
            this.FCProductModalItem = product
            if(product.ProductName != this.variantNameCheck && this.fullCommerceTotal != 0){
                this.fullCommerceTotal = 0
                this.variantSelecetedList = []
                this.variantsTypeSelected = []
            }
            this.variantNameCheck = product.ProductName
            this.primaryClicked = false
            
        },
        addQuantity: function(event,product,value,type){
            
            document.getElementById(value+"I").style.display = 'block'
             document.getElementById(event.currentTarget.id).style.display = 'none'
             document.getElementById(value).value = 1
             if(this.easyCommerce){
                 this.modalItemList.push({name:product.ProductName,cost:type.OfferPrice,quantity:1,variant:value,currency:product.CurrencyText,BH:new Date().getTime(),VID:type.VID,productHandle:product.ProductHandle,PLID:product.BranchPriceListID})
             }
             else if(!this.easyCommerce){
                 var variantSelected = []
                 variantSelected.push({VVID1:type.VID})
                 this.modalItemList.push({name:product.ProductName,cost:type.OfferPrice,quantity:1,variant:value,currency:product.CurrencyText,BH:new Date().getTime(),VID:type.VID,productHandle:product.ProductHandle,PLID:product.BranchPriceListID,variantList:variantSelected})
             }
             
             
             this.modalTotalCount = this.modalTotalCount + type.OfferPrice
        },
        add: function(value,product,type){
            
            console.log(this.modalItemList)
            document.getElementById(value).value = Number(document.getElementById(value).value) + 1
            this.modalTotalCount = this.modalTotalCount + type.OfferPrice;
            console.log(document.getElementById(value).value)
            for(var i=0;i<this.modalItemList.length;i++){
                if(this.modalItemList[i].name == product.ProductName && value.includes(this.modalItemList[i].variant)){
                    console.log(this.modalItemList[i].quantity)
                    this.modalItemList[i].quantity =  this.modalItemList[i].quantity + 1
                }
            }
            console.log(this.itemList)
            // for(var j=0;j<this.itemList.length;j++){
            //     if(this.itemList[j].name == product.ProductName && value.includes(this.itemList[j].variant)){
            //         this.itemList[j].quantity =  this.itemList[j].quantity + 1
            //     }
            // }

            sessionStorage.setItem(this.$route.params.handle,JSON.stringify(this.modalItemList))
            this.$root.$emit('ItemSelected',this.itemList)
            
        },
        minus: function(value,product,type){
            if(document.getElementById(value).value != 0){
            document.getElementById(value).value = document.getElementById(value).value - 1
            this.modalTotalCount = this.modalTotalCount - type.OfferPrice

            for(var i=0;i<this.modalItemList.length;i++){
                document.getElementById(this.modalItemList[i].productHandle + 'I').style.display = 'block'
                document.getElementById(this.modalItemList[i].productHandle + 'V').style.display = 'none'
                if(this.modalItemList[i].name == product.ProductName && value.includes(this.modalItemList[i].variant)){
                    this.modalItemList[i].quantity =  this.modalItemList[i].quantity - 1
                }
            }
            console.log(this.modalItemList)
            // for(var j=0;j<this.itemList.length;j++){
            //     if(this.itemList[j].name == product.ProductName && value.includes(this.itemList[j].variant)){
            //         this.itemList[j].quantity =  this.itemList[j].quantity - 1
            //     }
            // }
            this.$root.$emit('ItemSelected',this.itemList)
            if(document.getElementById(value).value == 0){
                document.getElementById(value + "V").style.display = 'block'
                document.getElementById(value + "I").style.display = 'none'
                for(var z=0;z<this.modalItemList.length;z++){
                     if(this.modalItemList[z].name == product.ProductName && value.includes(this.modalItemList[z].variant)){
                          var index = this.modalItemList.indexOf(this.modalItemList[z]);
                          this.modalItemList.splice(index,1);
                          var index1 = this.itemList.indexOf(this.modalItemList[z]);
                          this.itemList.splice(index1,1);
                          this.$root.$emit('ItemSelected',this.itemList)
                     }
                }
                 if(this.itemList.length == 0){
                        sessionStorage.removeItem(this.$route.params.handle)
                        this.$root.$emit('clearSession')
                    }
                    else{
                         sessionStorage.setItem(this.$route.params.handle,JSON.stringify(this.modalItemList))
                    }
            }
                 
            }

            if(JSON.parse(sessionStorage.getItem(this.$route.params.handle)).length == 0){
                sessionStorage.removeItem(this.$route.params.handle)
                this.$root.$emit('clearSession')
            }

            for(var m =0;m<this.modalItemList.length;m++){
                document.getElementById(this.modalItemList[m].productHandle + 'I').style.display = 'none'
                document.getElementById(this.modalItemList[m].productHandle + 'V').style.display = 'block'
            }

        },
        addListToCart(){
            if(this.itemList.length != 0 && this.itemList[0] != null){
                for(var i=0;i<this.itemList.length;i++){
                if(this.itemList[i].ServiceID == this.productList.ServiceID){
                    return
                }
            }
            }
           
            this.itemList.push({name:this.productList.CompanyService,cost:Number(this.modalTotalCount),quantity:1,variant:0,currency:this.currency,BH:new Date().getTime(),VID:this.addOnServiceList,productHandle:this.productList.ServiceID,PLID:0,timeStatement:this.timeStatement})
            this.$root.$emit('ItemSelected',this.itemList)
            this.itemAddedBoolean = true
                
        },
       
        open: function(string){
            const title = "InstaCiti Product Share"
            const url = "https://store.instaciti.com/"
            let params = 'scrollbars=no,resizable=no,status=no,location=no,menubar=no,width=600,height=500,left=100,top=100';
            if(string == "facebook"){
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + url + "&title=" + title,'share',params)

            }
            else if(string == "whatsapp"){
                window.open('whatsapp://send?text=' + url,'share',params)

            }
            else if(string == "twitter")
            window.open('https://twitter.com/intent/tweet?text=' + title + '&url=' + url,'share',params)
        },
        repeatSelectedItem: function(){
            document.getElementById(this.productToCustomize.ProductName+'productQuantity').value = Number(document.getElementById(this.productToCustomize.ProductName+'productQuantity').value) + 1

            for(var i=0;i<this.itemList.length;i++){
                if(this.itemList[i].name == this.productToCustomize.ProductName){
                    this.itemList[i].quantity =  this.itemList[i].quantity + 1
                     this.$root.$emit('ItemSelected',this.itemList)

                }
            }
        },
        chooseAgain: function(){
            var addComboBtn = document.getElementById('addComboBtn')
                    addComboBtn.click()
                    this.FCsendInfo(this.productToCustomize)
        },
        addProductQuantity: function(uniqueId,name){

           
            document.getElementById(uniqueId+'productQuantity').value = Number(document.getElementById(uniqueId+'productQuantity').value) + 1

            for(var i=0;i<this.itemList.length;i++){
                if(this.itemList[i].name == name){
                    
                    this.itemList[i].quantity =  this.itemList[i].quantity + 1
                     this.$root.$emit('ItemSelected',this.itemList)
                    console.log(this.itemList[i].quantity)
                }
            }
            
        },
        minusProductQuantity: function(uniqueId,name){
            if(document.getElementById(uniqueId+'productQuantity').value != 0){
            document.getElementById(uniqueId+'productQuantity').value = document.getElementById(uniqueId+'productQuantity').value - 1

            for(var i=0;i<this.itemList.length;i++){
                if(this.itemList[i].name == name ){
                    this.itemList[i].quantity =  this.itemList[i].quantity - 1
                    this.$root.$emit('ItemSelected',this.itemList)

                }
            }
            if(document.getElementById(uniqueId+'productQuantity').value == 0){
                document.getElementById(uniqueId + "V").style.display = 'none'
                document.getElementById(uniqueId + "I").style.display = 'block'
                for(var z=0;z<this.itemList.length;z++){
                     if(this.itemList[z].name == name ){
                          var index = this.itemList.indexOf(this.itemList[z]);
                          this.itemList.splice(index,1);
                     }
                }
                this.$root.$emit('ItemSelected',this.itemList)
                if(this.itemList.length == 0){
                    sessionStorage.removeItem(this.$route.params.handle)
                }

            }
            }
        },
        selectPrimaryVariant: function(itemSelected){
            this.primaryClicked = true
            this.selectedVariantId = itemSelected.VariantValueID
            this.fullCommerceTotal = this.fullCommerceTotal + itemSelected.OfferPrice
            this.variantSelecetedList = []
            this.variantsTypeSelected = []
            this.fullCommerceTotal = 0
            this.primaryVvid = itemSelected.VariantValueID
            
        },
        cartTotalFC: function(dependent,type,mandatory){
            
            if(type == 'M'){
                for(var i =0 ;i<this.variantSelecetedList.length;i++){
                    if(this.variantSelecetedList[i].VVID2 == dependent.VariantValueID){
                        const index = this.variantSelecetedList.indexOf(this.variantSelecetedList[i])
                        this.variantSelecetedList.splice(index,1);
                        const index2 = this.variantsTypeSelected.indexOf(dependent.VariantValue)
                        this.variantsTypeSelected.splice(index2,1);
                        this.fullCommerceTotal = this.fullCommerceTotal - dependent.OfferPrice
                        return
                    }
                }
                this.variantSelecetedList.push({"VVID1":this.primaryVvid,"VVID2":dependent.VariantValueID})
                this.variantsTypeSelected.push(dependent.VariantValue)
                this.fullCommerceTotal = this.fullCommerceTotal + dependent.OfferPrice
            }
            else if(type == 'O'){
                
                // if(this.variantSelecetedList.length != 0){
                //     console.log(this.variantSelecetedList[0].ProductVariantID)
                //     if(this.variantSelecetedList[0].ProductVariantID != dependent.ProductVariantID && this.primaryClicked == false){
                //         this.variantSelecetedList = []
                //         this.variantsTypeSelected = []
                //         // this.fullCommerceTotal = 0
                //     }   
                // }

                if(mandatory == 'Y'){
                    
                    this.variantSelecetedList = []
                    this.variantsTypeSelected = []
                    this.fullCommerceTotal = dependent.OfferPrice
                    this.variantSelecetedList.push({"VVID1":dependent.VariantValueID})
                    this.variantsTypeSelected.push(dependent.VariantValue)
                }
                else{
                    for(var j=0 ;j<this.variantSelecetedList.length;j++){
                    if(this.variantSelecetedList[j].VVID1 == dependent.VariantValueID){
                        
                        const index = this.variantSelecetedList.indexOf(this.variantSelecetedList[j])
                        this.variantSelecetedList.splice(index,1);
                        const index1 = this.variantsTypeSelected.indexOf(dependent.VariantValue)
                        this.variantsTypeSelected.splice(index1,1);
                        this.fullCommerceTotal = this.fullCommerceTotal - dependent.OfferPrice
                        return
                    }
                }
                this.variantSelecetedList.push({"VVID1":dependent.VariantValueID})
                this.variantsTypeSelected.push(dependent.VariantValue)
                this.fullCommerceTotal = this.fullCommerceTotal + dependent.OfferPrice
                
                }

            

                
            }
            
        },
        daySelect: function(day){
            this.shiftList = []
            this.timeStatement = ''
            document.getElementById(day).classList.add("active-day")

            for(var i=0;i<this.weekdaysArray.length;i++){
                if(this.weekdaysArray[i] != day){
                    document.getElementById(this.weekdaysArray[i]).classList.remove("active-day")
                }
            }
            
            for(var j=0;j<this.shift.length;j++){
                if(this.shift[j][day.substring(0,3)] == 'Y'){
                    this.shiftList.push(this.shift[j])
                   
                }
            }

            this.timeStatement = day;
        },

        shiftSelect: function(shift){
            this.slotList = []
            this.timeStatement = this.timeStatement.split(',')[0]
            document.getElementById(shift.ShiftName).classList.add("active-day")

            for(var i=0;i<this.shiftList.length;i++){
                if(this.shiftList[i].ShiftName != shift.ShiftName){
                    document.getElementById(this.shiftList[i].ShiftName).classList.remove("active-day")
                }
            }

            for(var j=0;j<this.slots.length;j++){
                if(this.slots[j].ShiftID == shift.CompanyShiftID){
                    
                    if(this.timeStatement.includes(this.currentDate)){
                        if(this.slots[j].CutOffTime.split(":")[0] == new Date().getHours()){
                        if(this.slots[j].CutOffTime.split(":")[1] > new Date().getMinutes())
                        this.slotList.push(this.slots[j])
                    }
                        if(this.slots[j].CutOffTime.split(":")[0] > new Date().getHours()){
                        this.slotList.push(this.slots[j])
                     }
                    }
                    else{
                        this.slotList.push(this.slots[j])
                    }
                    
                    
                   
                }
            }
            this.timeStatement = this.timeStatement + ', ' + shift.ShiftName;
        },
        slotSelect: function(slot){
            
            document.getElementById(slot.StartTime).classList.add("active-day")
            this.timeStatement = this.timeStatement + ' at ' + slot.StartTime;
            for(var i=0;i<this.slotList.length;i++){
                if(this.slotList[i].StartTime != slot.StartTime){
                    document.getElementById(this.slotList[i].StartTime).classList.remove("active-day")
                }
            }
            this.bookSlotBoolean = false
            if(this.editSlotValue == ''){
                this.addItem(this.productToBeScheduled);
            }
            else{
                for(var j=0;j<this.itemList.length;j++){
                    if(this.itemList[j].name == this.editSlotValue){
                        this.itemList[j].timeStatement = this.timeStatement
                        this.itemList[j].location = this.serviceLocation
                    }
                }
                this.editSlotValue = ''
            }
            
            this.itemAddedBoolean = true

            
        },
        addVariantstoCart: function(productToAdd){
            console.log(this.variantSelecetedList)
            if(this.variantSelecetedList != null && this.variantsTypeSelected.length !=0){
                //  for(var i=0;i<this.fullCommerceVariantList.length;i++){
                //      if(this.fullCommerceVariantList[i].name == productToAdd.ProductName){
                //          this.fullCommerceVariantList[i].variant = this.variantsTypeSelected
                //          this.fullCommerceVariantList[i].cost = this.fullCommerceTotal
                //          this.itemList = this.fullCommerceVariantList
                //          this.$root.$emit('ItemSelected',this.itemList)
                //         return
                //      }
                     
                //  }
            
            document.getElementById(productToAdd.productHandle+'V').style.display = 'block'
            document.getElementById(productToAdd.productHandle + 'I').style.display = 'none'
            if(Number(document.getElementById(productToAdd.productHandle+'productQuantity').value) != 0){
                document.getElementById(productToAdd.productHandle+'productQuantity').value = Number(document.getElementById(productToAdd.ProductName+'productQuantity').value) + 1
            }
            else{
                document.getElementById(productToAdd.productHandle+'productQuantity').value = 1
            }
            
                console.log(this.variantsTypeSelected)
                // this.fullCommerceTotal = this.fullCommerceTotal + this.FCProductModalItem.OfferPrice
                this.fullCommerceVariantList.push({name:productToAdd.ProductName,cost:this.fullCommerceTotal,quantity:1,variant:this.variantsTypeSelected,currency:productToAdd.CurrencyText,BH:new Date().getTime(),VID:'',productHandle:productToAdd.ProductHandle,variantList:this.variantSelecetedList,PLID:productToAdd.BranchPriceListID})
                console.log(this.fullCommerceVariantList)
                this.itemList = this.fullCommerceVariantList
                this.$root.$emit('ItemSelected',this.itemList)
                
                
            }
            


        }
    }

}


</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.cServiceClick {
    cursor: pointer;
    border: 2px solid #3A1593;
    color: #3A1593;
    font-weight: 500;
}

</style>
